import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useMemo, useRef } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { Card, CardBody, Nav, Row, Col, Form, Button, Modal, ButtonGroup, DropdownButton, // Accordion,
Dropdown } from "react-bootstrap";
import { Stack, Switch, FormControlLabel } from "@mui/material";
import Select from "react-select";
import { Formik } from "formik";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { ModalAllder } from "layouts/ModalAllder";
import ThaiBahtText from "thai-baht-text";
import DownloadExcel from "utils/DownloadExcel";
import DataTableLayout from "layouts/DatatableLayout";
import DatatableLayoutPagination from "layouts/DatatableLayoutPagination";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import EditIcon from "@mui/icons-material/Edit";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { nanoid } from "nanoid";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { StepperLabelWizard } from "layouts/StepperLabelWizard";
import { useReactToPrint } from "react-to-print";
import "styles/print.css";
import { NumberFormat, getInfoAdminSystem, filterTextAndNum, getPrefixName, WDA } from "utils/HelperFunction";
import { DndContext, closestCenter, KeyboardSensor, useSensor, useSensors, MouseSensor, TouchSensor } from "@dnd-kit/core";
import { restrictToVerticalAxis } from "@dnd-kit/modifiers";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import ColumnResizer from "react-table-column-resizer";
import { billing } from "../../redux/handlers/billing/billing.handler";
import { getBillingByID } from "../../redux/handlers/billing/getBillingByID.handler";
import { getQuotationByID } from "../../redux/handlers/billing/getQuotationByID.handler";
import { billingQuotationList } from "../../redux/handlers/billing/billingQuotationList.handler";
import { getAllMstBusiness } from "../../redux/handlers/master/getAllMstBusiness.handler";
import { createBilling, clearcreateBilling } from "../../redux/handlers/billing/createBilling.handler";
import { updateBilling, clearupdateBilling } from "../../redux/handlers/billing/updateBilling.handler";
import { uploadBilling } from "../../redux/handlers/billing/uploadBilling.handler";
import { createbybilling, clearcreatebybilling } from "../../redux/handlers/invoice/createbybilling.handler";
import { updateBillingCancel, clearupdateBillingCancel } from "../../redux/handlers/billing/updateBillingCancel.handler";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import LanguageIcon from "@mui/icons-material/Language";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PaymentsIcon from "@mui/icons-material/Payments";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import { Page, Text, View, Document, StyleSheet, Font, Image, pdf } from "@react-pdf/renderer";
import thsarabun from "fonts/THSarabunNew.ttf";
import thsarabunBold from "fonts/THSarabunNewBold.ttf";
export function Billing() {
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(""), 2), filterText = _useState[0], setFilterText = _useState[1];
    var _useState1 = _sliced_to_array(useState(0), 2), tabStatus = _useState1[0], setTabStatus = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), rowData = _useState2[0], setRowData = _useState2[1];
    var _useState3 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1000,
        height: 500,
        pin: false,
        mode: "normal",
        modalname: "pr-product-display"
    }), 2), modalQuotation = _useState3[0], setModalQuotation = _useState3[1];
    var _useState4 = _sliced_to_array(useState(1), 2), pageId = _useState4[0], setPageId = _useState4[1];
    var _useState5 = _sliced_to_array(useState(10), 2), pageSize = _useState5[0], setPageSize = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), sortModel = _useState6[0], setSortModel = _useState6[1];
    var _useState7 = _sliced_to_array(useState(false), 2), loading = _useState7[0], setLoading = _useState7[1];
    var _useState8 = _sliced_to_array(useState(0), 2), totalPage = _useState8[0], setTotalPage = _useState8[1];
    var _useState9 = _sliced_to_array(useState(0), 2), totalAmount = _useState9[0], setTotalAmount = _useState9[1];
    var _useState10 = _sliced_to_array(useState(""), 2), sExpireDate = _useState10[0], setsExpireDate = _useState10[1];
    var _useState11 = _sliced_to_array(useState(""), 2), eExpireDate = _useState11[0], seteExpireDate = _useState11[1];
    var _useState12 = _sliced_to_array(useState(""), 2), sIssueDate = _useState12[0], setsIssueDate = _useState12[1];
    var _useState13 = _sliced_to_array(useState(""), 2), eIssueDate = _useState13[0], seteIssueDate = _useState13[1];
    var billingReducer = useAppSelector(function(state) {
        return state.billingReducer;
    });
    useEffect(function() {
        setIsLoading(billingReducer.isFetching);
        setLoading(billingReducer.isFetching);
        if (billingReducer.data) {
            var _billingReducer_data_data, _billingReducer_data, _billingReducer_data_data1, _billingReducer_data1;
            var data = billingReducer === null || billingReducer === void 0 ? void 0 : (_billingReducer_data = billingReducer.data) === null || _billingReducer_data === void 0 ? void 0 : (_billingReducer_data_data = _billingReducer_data.data) === null || _billingReducer_data_data === void 0 ? void 0 : _billingReducer_data_data.data;
            var pagination = (billingReducer === null || billingReducer === void 0 ? void 0 : (_billingReducer_data1 = billingReducer.data) === null || _billingReducer_data1 === void 0 ? void 0 : (_billingReducer_data_data1 = _billingReducer_data1.data) === null || _billingReducer_data_data1 === void 0 ? void 0 : _billingReducer_data_data1.pagination) || {};
            setRowData(data);
            setTotalPage((pagination === null || pagination === void 0 ? void 0 : pagination.totalPage) || 0);
            setTotalAmount((pagination === null || pagination === void 0 ? void 0 : pagination.total) || 0);
        }
    }, [
        billingReducer
    ]);
    useEffect(function() {
        var data = _object_spread({
            pageId: parseInt(pageId),
            pageSize: parseInt(pageSize)
        }, tabStatus && {
            status: parseInt(tabStatus)
        }, filterText && {
            searchtxt: filterText
        }, sExpireDate && {
            sExpireDate: moment(sExpireDate).format("YYYY-MM-DD")
        }, eExpireDate && {
            eExpireDate: moment(eExpireDate).format("YYYY-MM-DD")
        }, sIssueDate && {
            sIssueDate: moment(sIssueDate).format("YYYY-MM-DD")
        }, eIssueDate && {
            eIssueDate: moment(eIssueDate).format("YYYY-MM-DD")
        }, sortModel && {
            sortField: sortModel.sortField,
            sortValue: sortModel.sortValue
        });
        dispatch(billing(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        pageId,
        pageSize,
        sortModel,
        sExpireDate,
        eExpireDate,
        sExpireDate,
        eIssueDate,
        filterText,
        tabStatus
    ]);
    var columns = [
        {
            name: "เลขที่ใบแจ้งหนี้",
            selector: function(row) {
                return row.bl_billing_code;
            },
            center: "true",
            width: "180px",
            sortable: true,
            sortField: "bl_billing_code",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/billing/edit/" + row.bl_billing_id,
                        children: row.bl_billing_code ? row.bl_billing_code : "ไม่มีรหัส"
                    })
                });
            }
        },
        {
            name: "อ้างอิงใบเสนอราคา",
            selector: function(row) {
                return row.QrQuotation ? row.QrQuotation.qr_quotation_code : "-";
            },
            center: "true",
            width: "180px",
            sortable: true,
            sortField: "qr_quotation_code",
            cell: function(row, index, column, id) {
                return row.bl_billing_quotid ? /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/quotation/edit/" + row.bl_billing_quotid,
                        children: row.QrQuotation ? row.QrQuotation.qr_quotation_code : "-"
                    })
                }) : "-";
            }
        },
        {
            name: "ชื่อกิจการ",
            sortable: true,
            sortField: "bl_billing_name",
            selector: function(row) {
                return row.bl_billing_businesstype ? row.bl_billing_businesstype == 1 ? row.bl_billing_fname ? row.bl_billing_fname + " " + row.bl_billing_lname : "-" : row.bl_billing_name ? /*#__PURE__*/ _jsxs("div", {
                    children: [
                        row.bl_billing_name,
                        /*#__PURE__*/ _jsx("br", {}),
                        /*#__PURE__*/ _jsx("span", {
                            className: "figure-caption",
                            children: row.bl_billing_taxid
                        })
                    ]
                }) : "-" : "-";
            },
            width: "300px"
        },
        {
            name: "สาขา",
            sortable: true,
            sortField: "bl_billing_businesstype",
            selector: function(row) {
                return row.bl_billing_businesstype == 2 ? row.bl_billing_branchname ? row.bl_billing_branchname : "-" : "-";
            }
        },
        {
            name: "ยอดเงิน (บาท)",
            selector: function(row) {
                return NumberFormat(row.bl_billing_totalnet, 2);
            },
            right: true,
            sortable: true,
            sortField: "bl_billing_totalnet",
            width: "180px"
        },
        {
            name: "รอบการชำระ",
            selector: function(row) {
                return row.bl_billing_expiredate ? moment(row.bl_billing_expiredate).format("DD/MM/YYYY") : "-";
            },
            center: "true",
            width: "180px",
            sortable: true,
            sortField: "bl_billing_expiredate"
        },
        {
            name: "วันที่ออกเอกสาร",
            selector: function(row) {
                return row.bl_billing_issuedate ? moment(row.bl_billing_issuedate).format("DD/MM/YYYY") : "-";
            },
            center: "true",
            width: "180px",
            sortable: true,
            sortField: "bl_billing_issuedate"
        },
        {
            name: "วันที่กำหนดชำระ",
            selector: function(row) {
                return row.bl_billing_expiredate;
            },
            center: "true",
            width: "180px",
            sortable: true,
            sortField: "bl_billing_expiredate",
            cell: function(row, index, column, id) {
                return row.bl_billing_expiredate ? /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            children: moment(row.bl_billing_expiredate).format("DD/MM/YYYY")
                        }),
                        row.bl_billing_status <= 3 && moment(new Date()).format("YYYY-MM-DD") > moment(row.bl_billing_expiredate).format("YYYY-MM-DD") ? /*#__PURE__*/ _jsx("div", {
                            className: "fs-12 text-danger",
                            children: "เกินระยะเวลาชำระ"
                        }) : ""
                    ]
                }) : "-";
            }
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.bl_billing_status;
            },
            sortable: true,
            sortField: "bl_billing_status",
            center: "true",
            width: "180px",
            cell: function(row, index, column, id) {
                return row.bl_billing_status == 1 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ร่างแบบ"
                }) || row.bl_billing_status == 2 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#FDB428",
                        backgroundColor: "#FFF6E5",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "รออนุมัติ"
                }) || row.bl_billing_status == 3 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#10B02A",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "อนุมัติแล้ว"
                }) || row.bl_billing_status == 4 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#10B02A",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ไม่อนุมัติ"
                }) || row.bl_billing_status == 5 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#F95057",
                        backgroundColor: "#FFE3E3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ยกเลิก"
                }) || row.bl_billing_status == 6 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgb(247 9 236)",
                        backgroundColor: "rgb(248 229 251)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "รับชำระ"
                });
            }
        }
    ];
    var handleChangePage = function(newPage) {
        setPageId(newPage);
    };
    var handleChangeRowsPerPage = function(newPageSize) {
        setPageSize(newPageSize);
    };
    var handleSort = function(column, sortDirection) {
        var field = column === null || column === void 0 ? void 0 : column.sortField;
        var value = sortDirection; // 'asc' หรือ 'desc'
        console.log("Sort:", {
            sortField: field,
            sortValue: value
        });
        setSortModel({
            sortField: field,
            sortValue: value
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "ใบแจ้งหนี้"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: "ใบแจ้งหนี้"
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsxs(Nav, {
                        variant: "pills",
                        defaultActiveKey: tabStatus,
                        onSelect: function(selectedKey) {
                            return setTabStatus(selectedKey);
                        },
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "0",
                                    children: "ทั้งหมด"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "1",
                                    children: "แบบร่าง"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "2",
                                    children: "รออนุมัติ"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "3",
                                    children: "อนุมัติแล้ว"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "6",
                                    children: "รับชำระ"
                                })
                            }),
                            /*#__PURE__*/ _jsx(Nav.Item, {
                                children: /*#__PURE__*/ _jsx(Nav.Link, {
                                    className: "tc-13 nav-danger",
                                    eventKey: "5",
                                    children: "ยกเลิก"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(Card, {
                        children: [
                            /*#__PURE__*/ _jsxs(CardBody, {
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "row gx-xl-4 mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "col-xl-1 col-md-12",
                                                children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                                    data: rowData,
                                                    filename: "ใบแจ้งหนี้"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "col-xl-6 col-md-12",
                                                children: /*#__PURE__*/ _jsxs(Stack, {
                                                    direction: "row",
                                                    justifyContent: "flex-start",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: " mb-2 px-2 w-[380px] ml-7",
                                                            children: "วันที่รอบการชำระ"
                                                        }),
                                                        /*#__PURE__*/ _jsx(DatePicker, {
                                                            selected: sExpireDate,
                                                            onChange: function(date) {
                                                                return setsExpireDate(date);
                                                            },
                                                            dateFormat: "dd-MM-yyyy",
                                                            className: "form-control px-2 mb-2",
                                                            isClearable: true
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "mb-2 px-2",
                                                            children: "ถึง"
                                                        }),
                                                        /*#__PURE__*/ _jsx(DatePicker, {
                                                            selected: eExpireDate,
                                                            onChange: function(date) {
                                                                return seteExpireDate(date);
                                                            },
                                                            dateFormat: "dd-MM-yyyy",
                                                            className: "form-control px-2 mb-2",
                                                            isClearable: true
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "col-xl-3 col-md-12",
                                                children: /*#__PURE__*/ _jsx("input", {
                                                    type: "text",
                                                    className: "form-control mb-2",
                                                    placeholder: "ค้นหาเลขใบแจ้งหนี้",
                                                    onKeyUp: function(e) {
                                                        return setFilterText(e.target.value);
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "col-xl-2 col-md-12",
                                                children: /*#__PURE__*/ _jsxs(Dropdown, {
                                                    children: [
                                                        /*#__PURE__*/ _jsx(Dropdown.Toggle, {
                                                            className: "btn btn-dg fs-14 ml-2 px-4 w-100 mb-2",
                                                            style: {
                                                                backgroundColor: "#B00412",
                                                                borderColor: "#B00412",
                                                                height: "40px"
                                                            },
                                                            children: "สร้างใบแจ้งหนี้"
                                                        }),
                                                        /*#__PURE__*/ _jsxs(Dropdown.Menu, {
                                                            className: "p-0 border-0",
                                                            children: [
                                                                /*#__PURE__*/ _jsx(Link, {
                                                                    className: "btn btn-st-6 w-100",
                                                                    to: "/billing/create",
                                                                    children: "สร้างใบแจ้งหนี้"
                                                                }),
                                                                /*#__PURE__*/ _jsx(Link, {
                                                                    className: "btn btn-st-6 w-100",
                                                                    onClick: function() {
                                                                        return setModalQuotation(function(prev) {
                                                                            return _object_spread_props(_object_spread({}, prev), {
                                                                                open: true
                                                                            });
                                                                        });
                                                                    },
                                                                    children: "โหลดเอกสาร"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "row gx-xl-4",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "col-xl-6 col-md-12",
                                            children: /*#__PURE__*/ _jsxs(Stack, {
                                                direction: "row",
                                                justifyContent: "flex-start",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: " mb-2 px-2 w-[350px]",
                                                        children: "วันที่ออกเอกสาร"
                                                    }),
                                                    /*#__PURE__*/ _jsx(DatePicker, {
                                                        selected: sIssueDate,
                                                        onChange: function(date) {
                                                            return setsIssueDate(date);
                                                        },
                                                        dateFormat: "dd-MM-yyyy",
                                                        className: "form-control px-2 mb-2",
                                                        isClearable: true
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mb-2 px-2",
                                                        children: "ถึง"
                                                    }),
                                                    /*#__PURE__*/ _jsx(DatePicker, {
                                                        selected: eIssueDate,
                                                        onChange: function(date) {
                                                            return seteIssueDate(date);
                                                        },
                                                        dateFormat: "dd-MM-yyyy",
                                                        className: "form-control px-2 mb-2",
                                                        isClearable: true
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(DatatableLayoutPagination, {
                                item: rowData,
                                columns: columns,
                                isSelectRows: false,
                                currentPage: pageId,
                                currentPageSize: pageSize,
                                onChangePage: handleChangePage,
                                onChangePageSize: handleChangeRowsPerPage,
                                totalPage: totalPage,
                                totalAmount: totalAmount,
                                sortModel: sortModel,
                                onChangeSort: setSortModel,
                                handleSort: handleSort,
                                loading: loading
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalQuotation,
                setModal: setModalQuotation,
                htitle: "โหลดเอกสาร",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(QuotationLists, {
                    // values={values}
                    // payDate={payDate}
                    setIsLoading: setIsLoading,
                    modalObj: modalObj,
                    setModalObj: setModalObj,
                    modal: modalQuotation,
                    setModal: setModalQuotation,
                    // setPayment={setPayment}
                    dispatch: dispatch
                })
            })
        ]
    });
}
function QuotationLists(param) {
    var setIsLoading = param.setIsLoading, dispatch = param.dispatch, modalObj = param.modalObj, setModalObj = param.setModalObj, setModal = param.setModal, modal = param.modal;
    var navigate = useNavigate();
    var _useState = _sliced_to_array(useState([]), 2), row = _useState[0], setRow = _useState[1];
    var _useState1 = _sliced_to_array(useState(null), 2), prSelected = _useState1[0], setPrSelected = _useState1[1];
    var billingQuotationListReducer = useAppSelector(function(state) {
        return state.billingQuotationListReducer;
    });
    useEffect(function() {
        var search = "";
        dispatch(billingQuotationList(search, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, []);
    useEffect(function() {
        setIsLoading(billingQuotationListReducer.isFetching);
        if (billingQuotationListReducer.data) {
            var data = billingQuotationListReducer.data.data;
            setRow(data);
        // setFilteredItems(data);
        }
    }, [
        billingQuotationListReducer
    ]);
    var columns = [
        {
            name: "",
            selector: function(row) {
                return row.qr_quotation_id;
            },
            center: "true",
            width: "80px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(Form.Check, {
                    type: "radio",
                    id: "t".concat(row.qr_quotation_id),
                    className: "form-check-st-2 tc-7 ms-4",
                    checked: prSelected && prSelected.qr_quotation_id == row.qr_quotation_id,
                    onChange: function(e) {
                        setPrSelected(row);
                    }
                });
            }
        },
        {
            name: "เลขที่ใบเสนอราคา",
            selector: function(row) {
                return row.qr_quotation_code;
            },
            center: "true"
        },
        {
            name: "ชื่อลูกค้า",
            selector: function(row) {
                return row.qr_quotation_businesstype == 1 ? row.qr_quotation_fname + " " + row.qr_quotation_lname : row.qr_quotation_comprefixname + row.qr_quotation_name + row.qr_quotation_suffixname + row.qr_quotation_branchname + "(" + row.qr_quotation_vatcode + ")";
            },
            center: "true"
        },
        {
            name: "รายการสินค้า",
            selector: function(row) {
                return row.QrDetail.length > 0 ? row.QrDetail.map(function(ele, i) {
                    return /*#__PURE__*/ _jsx("div", {
                        children: ele.qr_detail_name
                    }, i);
                }) : "";
            },
            center: "true"
        },
        {
            name: "จำนวน",
            selector: function(row) {
                return row.qr_quotation_totallist ? row.qr_quotation_totallist : 0;
            },
            center: "true"
        },
        {
            name: "วันที่เสนอราคา",
            selector: function(row) {
                return moment(row.qr_quotation_issuedate).format("DD/MM/YYYY");
            },
            center: "true"
        },
        {
            name: "ยอดรวม",
            selector: function(row) {
                return NumberFormat(row.qr_quotation_totalnet, 2);
            },
            center: "true"
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.qr_quotation_status;
            },
            center: "true",
            cell: function(row, index, column, id) {
                return row.qr_quotation_status == 1 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#6D788D)",
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ร่างแบบ"
                }) || row.qr_quotation_status == 2 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#FDB428",
                        backgroundColor: "#FFF6E5",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "รออนุมัติ"
                }) || row.qr_quotation_status == 3 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#10B02A",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "อนุมัติแล้ว"
                }) || row.qr_quotation_status == 4 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#10B02A",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ไม่อนุมัติ"
                }) || row.qr_quotation_status == 5 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#F95057",
                        backgroundColor: "#FFE3E3",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "ยกเลิก"
                }) || row.qr_quotation_status == 6 && /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#10B02A",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "150px"
                    },
                    children: "หมดอายุ"
                });
            }
        }
    ];
    var onClickModel = function() {
        console.log("5555", prSelected);
        if (prSelected) {
            navigate("/billing/quotation/edit/" + prSelected.qr_quotation_id);
        // navigator={"/billing/edit/" + row.bl_billing_id}
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx(DataTableLayout, {
                item: row,
                columns: columns,
                isSelectRows: false,
                PerPage: 10
            }),
            /*#__PURE__*/ _jsxs(Stack, {
                direction: "row",
                justifyContent: "flex-end",
                className: "mt-4",
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        type: "button",
                        className: "btn-st-6 me-3 btn",
                        onClick: function() {
                            return setModal(function(prev) {
                                return _object_spread_props(_object_spread({}, prev), {
                                    open: false
                                });
                            });
                        },
                        children: "ยกเลิก"
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        // type="submit"
                        onClick: function() {
                            onClickModel();
                        },
                        className: "btn-st-3 me-3",
                        children: "ยืนยัน"
                    })
                ]
            })
        ]
    });
}
export function BillingCreate() {
    var schema = yup.object().shape({
    });
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var param = useParams();
    var dataID = useMemo(function() {
        return param.dataID ? param.dataID : null;
    }, [
        param.dataID
    ]);
    var poID = useMemo(function() {
        return param.poID ? param.poID : null;
    }, [
        param.poID
    ]);
    var accessToken = localStorage.getItem("accessToken");
    var adminInfo = getInfoAdminSystem(accessToken);
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(false), 2), formdisabled = _useState[0], setFormdisabled = _useState[1];
    var _useState1 = _sliced_to_array(useState(1), 2), stepper = _useState1[0], setStepper = _useState1[1];
    var _useState2 = _sliced_to_array(useState(new Date()), 2), docDate = _useState2[0], setDocDate = _useState2[1];
    var _useState3 = _sliced_to_array(useState(new Date()), 2), dueDate = _useState3[0], setDueDate = _useState3[1];
    var _useState4 = _sliced_to_array(useState(new Date()), 2), payDate = _useState4[0], setPayDate = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), supplierInfos = _useState5[0], setSupplierInfos = _useState5[1];
    var _useState6 = _sliced_to_array(useState(1), 2), tabStatus = _useState6[0], setTabStatus = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), productRow = _useState7[0], setProductRow = _useState7[1];
    var _useState8 = _sliced_to_array(useState(1), 2), statusPage = _useState8[0], setstatusPage = _useState8[1];
    var _useState9 = _sliced_to_array(useState(0), 2), sumrowNoDiscount = _useState9[0], setSumrowNoDiscount = _useState9[1];
    var _useState10 = _sliced_to_array(useState(0), 2), sumrowBeforeVat = _useState10[0], setSumrowBeforeVat = _useState10[1];
    var _useState11 = _sliced_to_array(useState(0), 2), sumrowTotalNet = _useState11[0], setSumrowTotalNet = _useState11[1];
    var _useState12 = _sliced_to_array(useState(0), 2), sumrowQty = _useState12[0], setSumrowQty = _useState12[1];
    var _useState13 = _sliced_to_array(useState(0), 2), sumrowPrice = _useState13[0], setSumrowPrice = _useState13[1];
    var _useState14 = _sliced_to_array(useState(0), 2), sumrowDiscount = _useState14[0], setSumrowDiscount = _useState14[1];
    var _useState15 = _sliced_to_array(useState(0), 2), sumDiscount = _useState15[0], setSumDiscount = _useState15[1];
    var _useState16 = _sliced_to_array(useState(0), 2), sumrowVat = _useState16[0], setSumrowVat = _useState16[1];
    var _useState17 = _sliced_to_array(useState(0), 2), sumrowTax = _useState17[0], setSumrowTax = _useState17[1];
    var _useState18 = _sliced_to_array(useState([]), 2), docPath = _useState18[0], setDocPath = _useState18[1];
    var _useState19 = _sliced_to_array(useState([]), 2), docPathDel = _useState19[0], setDocPathDel = _useState19[1];
    var _useState20 = _sliced_to_array(useState([]), 2), productRowDel = _useState20[0], setProductRowDel = _useState20[1];
    var _useState21 = _sliced_to_array(useState(""), 2), tagselected = _useState21[0], setTagSelected = _useState21[1];
    var _useState22 = _sliced_to_array(useState(""), 2), remark = _useState22[0], setRemark = _useState22[1];
    var _useState23 = _sliced_to_array(useState(true), 2), taxSwitch = _useState23[0], setTaxSwitch = _useState23[1];
    var _useState24 = _sliced_to_array(useState([]), 2), payment = _useState24[0], setPayment = _useState24[1];
    var _useState25 = _sliced_to_array(useState([]), 2), invoice = _useState25[0], setInvoice = _useState25[1];
    var _useState26 = _sliced_to_array(useState(false), 2), modalsuccess = _useState26[0], setModalsuccess = _useState26[1];
    var _useState27 = _sliced_to_array(useState(false), 2), textsuccess = _useState27[0], setTextsuccess = _useState27[1];
    var _useState28 = _sliced_to_array(useState({}), 2), dataPrint = _useState28[0], setDataPrint = _useState28[1];
    var _useState29 = _sliced_to_array(useState({
        companyName: "",
        companyBranch: "",
        companyTaxId: "",
        companyAddress: "",
        companyProvince: "",
        companyDistrict: "",
        companySubDistrict: "",
        companyZipCode: "",
        contractName: "",
        contactPhone: "",
        contactEmail: ""
    }), 2), partnerInfo = _useState29[0], setPartnerInfo = _useState29[1];
    var _useState30 = _sliced_to_array(useState({
        barcode: false,
        supplierCode: false,
        productsOrdered: false,
        ums: false,
        productsStock: "",
        vat: false,
        valueIncludingTax: false
    }), 2), columdisplay = _useState30[0], setColumDisplay = _useState30[1];
    var _useState31 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 1200,
        height: 550,
        pin: false,
        mode: "normal",
        modalname: "pr-product-display"
    }), 2), modalPay = _useState31[0], setModalPay = _useState31[1];
    var _useState32 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 500,
        height: 250,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modalDel = _useState32[0], setModalDel = _useState32[1];
    var _useState33 = _sliced_to_array(useState({
        bl_billing_status: 1
    }), 2), formdata = _useState33[0], setFormdata = _useState33[1];
    var _useState34 = _sliced_to_array(useState({
        bl_billing_memid: "",
        bl_billing_issuedate: moment(new Date()).format("DD/MM/YYYY"),
        bl_billing_expiredate: moment(new Date()).format("DD/MM/YYYY"),
        bl_billing_paytype: 1,
        bl_billing_vattype: 1,
        bl_billing_discounttype: 1,
        bl_billing_discount: 0,
        bl_billing_status: 1,
        bl_billing_vat: 0,
        bl_billing_tax: 0
    }), 2), formData = _useState34[0], setFormData = _useState34[1];
    var dataSteps1 = [
        "สร้างใบเสร็จ",
        "รออนุมัติ",
        "เสร็จสิ้น"
    ];
    var dataSteps2 = [
        "สร้างใบเสร็จ",
        "รออนุมัติ",
        "รับชำระ",
        "ชำระแล้วบางส่วน",
        "เสร็จสิ้น"
    ];
    var optionsMstPaymentType = [
        {
            value: 1,
            label: "เงินสด"
        },
        {
            value: 2,
            label: "โอนธาคาร"
        },
        {
            value: 3,
            label: "เช็คเงินสด"
        }
    ];
    var optionsMstPriceType = [
        {
            value: 1,
            label: "รวมภาษี"
        },
        {
            value: 2,
            label: "ไม่รวมภาษี"
        }
    ];
    var optionsMstDiscountType = [
        {
            value: 1,
            label: "บาท"
        },
        {
            value: 2,
            label: "เปอร์เซ็น"
        }
    ];
    var optionsMstTax = [
        {
            value: 0,
            label: "-"
        },
        {
            value: 1,
            label: "1%"
        },
        {
            value: 2,
            label: "2%"
        },
        {
            value: 3,
            label: "3%"
        },
        {
            value: 5,
            label: "5%"
        }
    ];
    var formatResult = function(item) {
        return /*#__PURE__*/ _jsxs("div", {
            className: "fs-12",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    children: item.bus_business_company
                }),
                /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#f26f3a"
                    },
                    children: item.bus_business_taxid
                })
            ]
        }, item.bus_business_id);
    };
    // const componentRef = useRef();
    // const handlePrint = useReactToPrint({
    //   documentTitle: `ใบแจ้งหนี้${moment().format("DDMMYYYYHHmmss")}`,
    //   content: () => componentRef.current,
    // });
    var getBillingByIDReducer = useAppSelector(function(state) {
        return state.getBillingByIDReducer;
    });
    var getAllMstBusinessReducer = useAppSelector(function(state) {
        return state.getAllMstBusinessReducer;
    });
    var getQuotationByIDReducer = useAppSelector(function(state) {
        return state.getQuotationByIDReducer;
    });
    useEffect(function() {
        setIsLoading(getBillingByIDReducer.isFetching || getAllMstBusinessReducer.isFetching || getQuotationByIDReducer.isFetching);
        if (dataID) {
            if (getBillingByIDReducer.data) {
                var dataBill = getBillingByIDReducer.data.data;
                console.log("getBillingByIDReducer", dataBill);
                setDataPrint(dataBill);
                if (dataBill.bl_billing_status >= 3) {
                    setTabStatus(2);
                } else {
                    setTabStatus(1);
                }
                setFormData(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        bl_billing_id: dataBill.bl_billing_id,
                        bl_billing_code: dataBill.bl_billing_code,
                        bl_billing_refer: dataBill.QrQuotation ? dataBill.QrQuotation.qr_quotation_code : "",
                        bl_billing_issuedate: dataBill.bl_billing_issuedate ? moment(dataBill.bl_billing_issuedate).format("DD/MM/YYYY") : "",
                        bl_billing_expiredate: dataBill.bl_billing_expiredate ? moment(dataBill.bl_billing_expiredate).format("DD/MM/YYYY") : "",
                        bl_billing_paytype: dataBill.bl_billing_paytype ? dataBill.bl_billing_paytype : 1,
                        bl_billing_vattype: dataBill.bl_billing_vattype ? dataBill.bl_billing_vattype : 1,
                        bl_billing_totalprice: dataBill.bl_billing_totalprice ? dataBill.bl_billing_totalprice : 0,
                        bl_billing_discounttype: dataBill.bl_billing_discounttype ? dataBill.bl_billing_discounttype : 1,
                        bl_billing_discount: dataBill.bl_billing_discount ? dataBill.bl_billing_discount : 0,
                        bl_billing_status: dataBill.bl_billing_status ? dataBill.bl_billing_status : 1,
                        bl_billing_refercode: dataBill.bl_billing_refercode ? dataBill.bl_billing_refercode : "",
                        bl_billing_totalnet: dataBill.bl_billing_totalnet ? dataBill.bl_billing_totalnet : 0,
                        bl_billing_totalpay: dataBill.bl_billing_totalpay ? dataBill.bl_billing_totalpay : 0,
                        bl_billing_tax: dataBill.bl_billing_tax,
                        bl_billing_vat: dataBill.bl_billing_vat,
                        bl_billing_totalvat: dataBill.bl_billing_totalvat ? dataBill.bl_billing_totalvat : 0,
                        bl_billing_totaltax: dataBill.bl_billing_totaltax ? dataBill.bl_billing_totaltax : 0,
                        bl_billing_approvedate: dataBill.bl_billing_approvedate,
                        bl_billing_businessid: dataBill.bl_billing_businessid,
                        bl_billing_totalnetvat: dataBill.bl_billing_totalnetvat,
                        bl_billing_canceldate: dataBill.bl_billing_canceldate ? moment(dataBill.bl_billing_canceldate).format("DD/MM/YYYY") : ""
                    });
                });
                setFormdata({
                    bl_billing_businessid: dataBill.bl_billing_businessid,
                    bl_billing_quotid: dataBill.bl_billing_quotid ? dataBill.bl_billing_quotid : "",
                    bl_billing_status: dataBill.bl_billing_status ? dataBill.bl_billing_status : 1,
                    bl_billing_refercode: dataBill.bl_billing_refercode ? dataBill.bl_billing_refercode : "",
                    bl_billing_categoryid: dataBill.bl_billing_categoryid,
                    bl_billing_suffixname: dataBill.bl_billing_suffixname,
                    bl_billing_vatcode: dataBill.bl_billing_vatcode,
                    bl_billing_name: dataBill.bl_billing_name,
                    bl_billing_address: dataBill.bl_billing_address,
                    bl_billing_fname: dataBill.bl_billing_fname,
                    bl_billing_lname: dataBill.bl_billing_lname,
                    bl_billing_mainfname: dataBill.bl_billing_mainfname,
                    bl_billing_mainlname: dataBill.bl_billing_mainlname,
                    bl_billing_mainphone: dataBill.bl_billing_mainphone,
                    bl_billing_mainemail: dataBill.bl_billing_mainemail,
                    bl_billing_provinceid: dataBill.bl_billing_provinceid,
                    bl_billing_subprovinceid: dataBill.bl_billing_subprovinceid,
                    bl_billing_zipcodeid: dataBill.bl_billing_zipcodeid,
                    bl_billing_districtid: dataBill.bl_billing_districtid,
                    bl_billing_comprefixid: dataBill.bl_billing_comprefixid,
                    bl_billing_comprefixname: dataBill.bl_billing_comprefixname,
                    bl_billing_taxid: dataBill.bl_billing_taxid,
                    bl_billing_businesstype: dataBill.bl_billing_businesstype,
                    bl_billing_branchname: dataBill.bl_billing_branchname,
                    bl_billing_memid: dataBill.bl_billing_memid,
                    bl_billing_tax: dataBill.bl_billing_tax,
                    bl_billing_vat: dataBill.bl_billing_vat,
                    bl_billing_totalvat: dataBill.bl_billing_totalvat ? dataBill.bl_billing_totalvat : 0,
                    bl_billing_totaltax: dataBill.bl_billing_totaltax ? dataBill.bl_billing_totaltax : 0,
                    bl_billing_totalnetvat: dataBill.bl_billing_totalnetvat,
                    bl_billing_canceldate: dataBill.bl_billing_canceldate ? moment(dataBill.bl_billing_canceldate).format("DD/MM/YYYY") : ""
                });
                setPartnerInfo(_object_spread_props(_object_spread({}, partnerInfo), {
                    companyName: dataBill.bl_billing_businesstype == 2 ? filterTextAndNum(dataBill.bl_billing_comprefixname ? dataBill.bl_billing_comprefixname : "") + " " + filterTextAndNum(dataBill.bl_billing_name ? dataBill.bl_billing_name : "") + " " + filterTextAndNum(dataBill.bl_billing_suffixname ? dataBill.bl_billing_suffixname : "") : filterTextAndNum(dataBill.bl_billing_prefixid == 1 && "นาย" || dataBill.bl_billing_prefixid == 2 && "นาง" || dataBill.bl_billing_prefixid == 3 && "นางสาว" || dataBill.bl_billing_prefixid == 4 && "ไม่ระบุ" || dataBill.bl_billing_prefixid == "" && "") + " " + filterTextAndNum(dataBill.bl_billing_fname) + " " + filterTextAndNum(dataBill.bl_billing_lname),
                    companyBranch: dataBill.bl_billing_branchname ? dataBill.bl_billing_branchname : "",
                    companyTaxId: dataBill.bl_billing_taxid ? dataBill.bl_billing_taxid : "",
                    companyAddress: dataBill.bl_billing_address,
                    companyProvince: dataBill.Billprovinceid ? JSON.parse(dataBill.Billprovinceid.province_name).th : "",
                    companyDistrict: dataBill.Billdistrictid ? JSON.parse(dataBill.Billdistrictid.subdistrict_name).th : "",
                    companySubDistrict: dataBill.Billsubprovinceid ? JSON.parse(dataBill.Billsubprovinceid.district_name).th : "",
                    companyZipCode: dataBill.bl_billing_zipcodeid ? dataBill.bl_billing_zipcodeid : "",
                    contractName: dataBill.bl_billing_mainfname && dataBill.bl_billing_mainlname ? dataBill.bl_billing_mainfname + " " + dataBill.bl_billing_mainlname : "",
                    contactPhone: dataBill.bl_billing_mainphone ? dataBill.bl_billing_mainphone : "",
                    contactEmail: dataBill.bl_billing_mainemail ? dataBill.bl_billing_mainemail : ""
                }));
                var arrFile = [];
                dataBill === null || dataBill === void 0 ? void 0 : dataBill.BlFile.map(function(ele) {
                    return arrFile.push({
                        id: nanoid(),
                        bl_file_url: ele.bl_file_url,
                        type: "update",
                        bl_file_id: ele.bl_file_id
                    });
                });
                setDocPath(arrFile);
                var datalistData = [];
                dataBill.BlDetail.map(function(ele) {
                    return datalistData.push({
                        rowID: nanoid(),
                        bl_detail_amount: ele.bl_detail_amount ? ele.bl_detail_amount : 0,
                        bl_detail_billid: ele.bl_detail_billid ? ele.bl_detail_billid : "",
                        bl_detail_id: ele.bl_detail_id ? ele.bl_detail_id : "",
                        bl_detail_discount: ele.bl_detail_discount ? ele.bl_detail_discount : 0,
                        bl_detail_discountreal: ele.bl_detail_discountreal ? ele.bl_detail_discountreal : 0,
                        bl_detail_discounttype: ele.bl_detail_discounttype ? ele.bl_detail_discounttype : 1,
                        bl_detail_name: ele.bl_detail_name ? ele.bl_detail_name : "",
                        bl_detail_net: ele.bl_detail_net ? ele.bl_detail_net : 0,
                        bl_detail_price: ele.bl_detail_price ? ele.bl_detail_price : 0,
                        bl_detail_pricediscount: ele.bl_detail_pricediscount ? ele.bl_detail_pricediscount : 0,
                        bl_detail_remark: ele.bl_detail_remark ? ele.bl_detail_remark : "",
                        bl_detail_tax: ele.bl_detail_tax ? ele.bl_detail_tax : 0,
                        bl_detail_taxtype: ele.bl_detail_taxtype ? ele.bl_detail_taxtype : 0,
                        bl_detail_totalprice: ele.bl_detail_totalprice ? ele.bl_detail_totalprice : 0,
                        bl_detail_unit: ele.bl_detail_unit ? ele.bl_detail_unit : "",
                        bl_detail_vat: ele.bl_detail_vat ? ele.bl_detail_vat : 0,
                        bl_detail_vatnet: ele.bl_detail_vatnet ? ele.bl_detail_vatnet : 0,
                        bl_detail_vatprice: ele.bl_detail_vatprice ? ele.bl_detail_vatprice : 0,
                        type: "update"
                    });
                });
                setProductRow(datalistData);
                if (dataBill.InvInvoice.length > 0) {
                    var pay = [];
                    dataBill.InvInvoice.map(function(ele) {
                        return pay.push({
                            id: nanoid(),
                            inv_invoice_id: ele.inv_invoice_id,
                            inv_invoice_paytype: ele.inv_invoice_paytype,
                            inv_invoice_totalnet: ele.inv_invoice_totalnet,
                            inv_invoice_ramark: ele.inv_invoice_ramark,
                            inv_invoice_taxstatus: ele.inv_invoice_taxinvoice,
                            inv_invoice_issuedate: ele.inv_invoice_issuedate,
                            inv_invoice_code: ele.inv_invoice_code
                        });
                    });
                    setPayment(pay);
                } else {
                    var pay1 = [];
                    pay1.push({
                        id: nanoid(),
                        inv_invoice_id: null,
                        inv_invoice_issuedate: moment().format("DD/MM/YYYY"),
                        inv_invoice_paytype: 1,
                        inv_invoice_totalnet: dataBill.bl_billing_totalnet,
                        inv_invoice_ramark: "",
                        inv_invoice_taxstatus: taxSwitch == true ? 1 : 2,
                        inv_invoice_code: "",
                        type: "create"
                    });
                    setPayment(pay1);
                }
                setInvoice(dataBill.InvInvoice);
                setSumDiscount(dataBill.bl_billing_discountreal);
                setstatusPage(dataBill.bl_billing_status ? dataBill.bl_billing_status : 1);
                setStepper(dataBill.bl_billing_status ? dataBill.bl_billing_status : 1);
                setDocDate(new Date(dataBill.bl_billing_issuedate));
                setDueDate(new Date(dataBill.bl_billing_expiredate));
                setSumrowTotalNet(dataBill.bl_billing_pricediscount);
                setSumrowTax(dataBill.bl_billing_totaltax);
                setSumrowVat(dataBill.bl_billing_totalvat);
                setRemark(dataBill.bl_billing_ramark ? dataBill.bl_billing_ramark : "");
            }
        }
        if (poID) {
            if (getQuotationByIDReducer.data) {
                console.log("Quotation", getQuotationByIDReducer.data.data);
                var QuotationData = getQuotationByIDReducer.data.data;
                setFormData(function(prev) {
                    return _object_spread_props(_object_spread({}, prev), {
                        // bl_billing_code: getQuotationByIDReducer.data.data.qr_quotation_code,
                        bl_billing_issuedate: moment(QuotationData.qr_quotation_issuedate).format("DD/MM/YYYY"),
                        bl_billing_expiredate: moment(QuotationData.qr_quotation_expiredate).format("DD/MM/YYYY"),
                        bl_billing_refercode: QuotationData.qr_quotation_refercode,
                        bl_billing_paytype: QuotationData.qr_quotation_paytype,
                        bl_billing_vattype: QuotationData.qr_quotation_vattype,
                        bl_billing_totalprice: QuotationData.qr_quotation_totalprice,
                        bl_billing_discounttype: QuotationData.qr_quotation_discounttype,
                        bl_billing_discount: QuotationData.qr_quotation_discount,
                        bl_billing_refer: QuotationData.qr_quotation_code,
                        bl_billing_businessid: QuotationData.bl_billing_businessid,
                        bl_billing_totalnetvat: QuotationData.bl_billing_totalnetvat
                    });
                });
                setFormdata({
                    bl_billing_businessid: QuotationData.bl_billing_businessid,
                    bl_billing_refercode: QuotationData.qr_quotation_refercode,
                    bl_billing_quotid: QuotationData.qr_quotation_id,
                    bl_billing_contid: QuotationData.qr_quotation_contid,
                    bl_billing_address: QuotationData.qr_quotation_address,
                    bl_billing_branchname: QuotationData.qr_quotation_branchname,
                    bl_billing_businesstype: QuotationData.qr_quotation_businesstype,
                    bl_billing_categoryid: QuotationData.qr_quotation_categoryid,
                    bl_billing_comprefixid: QuotationData.qr_quotation_comprefixid,
                    bl_billing_comprefixname: QuotationData.qr_quotation_comprefixname,
                    bl_billing_discount: QuotationData.qr_quotation_discount,
                    bl_billing_discountreal: QuotationData.qr_quotation_discountreal,
                    bl_billing_discounttype: QuotationData.qr_quotation_discounttype,
                    bl_billing_districtid: QuotationData.qr_quotation_districtid,
                    bl_billing_fname: QuotationData.qr_quotation_fname,
                    bl_billing_lname: QuotationData.qr_quotation_lname,
                    bl_billing_mainemail: QuotationData.qr_quotation_mainemail,
                    bl_billing_mainfname: QuotationData.qr_quotation_mainfname,
                    bl_billing_mainlname: QuotationData.qr_quotation_mainlname,
                    bl_billing_mainphone: QuotationData.qr_quotation_mainphone,
                    bl_billing_memid: QuotationData.qr_quotation_memid,
                    bl_billing_name: QuotationData.qr_quotation_name,
                    bl_billing_paytype: QuotationData.qr_quotation_paytype,
                    bl_billing_pricediscount: QuotationData.qr_quotation_pricediscount,
                    bl_billing_provinceid: QuotationData.qr_quotation_provinceid,
                    bl_billing_subprovinceid: QuotationData.qr_quotation_subprovinceid,
                    bl_billing_suffixname: QuotationData.qr_quotation_suffixname,
                    bl_billing_taxid: QuotationData.qr_quotation_taxid,
                    bl_billing_status: 1,
                    bl_billing_totalnetvat: QuotationData.bl_billing_totalnetvat
                });
                setDocDate(new Date(QuotationData.qr_quotation_issuedate));
                setDueDate(new Date(QuotationData.qr_quotation_expiredate));
                setPartnerInfo(_object_spread_props(_object_spread({}, partnerInfo), {
                    companyName: QuotationData.qr_quotation_businesstype == 2 ? filterTextAndNum(QuotationData.qr_quotation_comprefixname ? QuotationData.qr_quotation_comprefixname : "") + " " + filterTextAndNum(QuotationData.qr_quotation_name ? QuotationData.qr_quotation_name : "") + " " + filterTextAndNum(QuotationData.qr_quotation_suffixname ? QuotationData.qr_quotation_suffixname : "") : filterTextAndNum(QuotationData.qr_quotation_prefixid == 1 && "นาย" || QuotationData.qr_quotation_prefixid == 2 && "นาง" || QuotationData.qr_quotation_prefixid == 3 && "นางสาว" || QuotationData.qr_quotation_prefixid == 4 && "ไม่ระบุ" || QuotationData.qr_quotation_prefixid == "" && "") + " " + filterTextAndNum(QuotationData.qr_quotation_fname ? QuotationData.qr_quotation_fname : "") + " " + filterTextAndNum(QuotationData.qr_quotation_lname ? QuotationData.qr_quotation_lname : ""),
                    companyBranch: QuotationData.qr_quotation_branchname ? QuotationData.qr_quotation_branchname : "",
                    companyTaxId: QuotationData.qr_quotation_taxid ? QuotationData.qr_quotation_taxid : "",
                    companyAddress: QuotationData.qr_quotation_address ? QuotationData.qr_quotation_address : "",
                    companyProvince: QuotationData.Qrprovinceid ? JSON.parse(QuotationData.Qrprovinceid.province_name).th : "",
                    companyDistrict: QuotationData.Qrdistrictid ? JSON.parse(QuotationData.Qrdistrictid.subdistrict_name).th : "",
                    companySubDistrict: QuotationData.Qrsubprovinceid ? JSON.parse(QuotationData.Qrsubprovinceid.district_name).th : "",
                    companyZipCode: QuotationData.qr_quotation_zipcodeid ? QuotationData.qr_quotation_zipcodeid : "",
                    contractName: QuotationData.qr_quotation_mainfname && QuotationData.qr_quotation_mainlname ? QuotationData.qr_quotation_mainfname + " " + QuotationData.qr_quotation_mainlname : "",
                    contactPhone: QuotationData.qr_quotation_mainphone ? QuotationData.qr_quotation_mainphone : "",
                    contactEmail: QuotationData.qr_quotation_mainemail ? QuotationData.qr_quotation_mainemail : ""
                }));
                var datalistData1 = [];
                QuotationData.QrDetail.map(function(ele) {
                    return datalistData1.push({
                        rowID: nanoid(),
                        bl_detail_amount: ele.qr_detail_amount ? ele.qr_detail_amount : 0,
                        bl_detail_discount: ele.qr_detail_discount ? ele.qr_detail_discount : 0,
                        bl_detail_discountreal: ele.qr_detail_discountreal ? ele.qr_detail_discountreal : 0,
                        bl_detail_discounttype: ele.qr_detail_discounttype ? ele.qr_detail_discounttype : 1,
                        bl_detail_name: ele.qr_detail_name ? ele.qr_detail_name : "",
                        bl_detail_net: ele.qr_detail_net ? ele.qr_detail_net : 0,
                        bl_detail_price: ele.qr_detail_price ? ele.qr_detail_price : 0,
                        bl_detail_pricediscount: ele.qr_detail_pricediscount ? ele.qr_detail_pricediscount : 0,
                        bl_detail_remark: ele.qr_detail_remark ? ele.qr_detail_remark : "",
                        bl_detail_taxtype: 0,
                        bl_detail_tax: "0.00",
                        bl_detail_totalprice: ele.qr_detail_price * ele.qr_detail_amount,
                        bl_detail_unit: ele.qr_detail_unit ? ele.qr_detail_unit : "",
                        bl_detail_vat: ele.qr_detail_vat ? ele.qr_detail_vat : 0,
                        bl_detail_vatnet: ele.bl_detail_vatnet ? ele.bl_detail_vatnet : 0,
                        bl_detail_vatprice: ele.qr_detail_vatprice ? ele.qr_detail_vatprice : 0,
                        type: "create"
                    });
                });
                setProductRow(datalistData1);
                setSumDiscount(QuotationData.qr_quotation_discounttype == 1 ? QuotationData.qr_quotation_discount : QuotationData.qr_quotation_totalprice * QuotationData.qr_quotation_discount / 100);
                setSumrowTotalNet(QuotationData.qr_quotation_pricediscount);
                setTagSelected(QuotationData.qr_quotation_tag ? QuotationData.qr_quotation_tag : "");
                setRemark(QuotationData.qr_quotation_ramark ? QuotationData.qr_quotation_ramark : "");
                var arrFile1 = [];
                QuotationData === null || QuotationData === void 0 ? void 0 : QuotationData.QrFile.map(function(ele) {
                    return arrFile1.push({
                        id: nanoid(),
                        bl_file_url: ele.qr_file_url,
                        type: "create"
                    });
                });
                setDocPath(arrFile1);
            }
        }
        if (getAllMstBusinessReducer.data) {
            var datas = getAllMstBusinessReducer.data.data.filter(function(item) {
                return item.bus_business_id !== null && item.bus_business_status == 3;
            });
            if (datas && datas.length > 0) {
                setSupplierInfos(datas.map(function(item, index) {
                    return _object_spread_props(_object_spread({}, item), {
                        bus_business_company: item.bus_business_businesstype === 2 ? filterTextAndNum(item.bus_business_comprefixname) + " " + filterTextAndNum(item.bus_business_name) + " " + filterTextAndNum(item.bus_business_suffixname) : item.bus_business_businesstype === 1 ? getPrefixName(item.bus_business_prefixid) + filterTextAndNum(item.bus_business_fname) + " " + filterTextAndNum(item.bus_business_lname) : "ไม่ระบุชื่อธุรกิจ " + (index + 1)
                    });
                }));
            }
        }
    }, [
        getBillingByIDReducer,
        getAllMstBusinessReducer,
        getQuotationByIDReducer
    ]);
    useEffect(function() {
        dispatch(getAllMstBusiness());
        setModalsuccess(false);
        if (dataID) {
            dispatch(getBillingByID(parseInt(dataID), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
        if (poID) {
            dispatch(getQuotationByID(parseInt(poID), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    }, [
        dataID,
        poID
    ]);
    var handleOpenPrint = function() {
        var _ref = _async_to_generator(function() {
            var blob, url, newWindow, fileName;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            pdf(/*#__PURE__*/ _jsx(PagePrintPDF, {
                                data: dataPrint,
                                formData: formData,
                                partnerInfo: partnerInfo,
                                sumrowTotalNet: sumrowTotalNet,
                                sumDiscount: sumDiscount,
                                sumrowVat: sumrowVat,
                                sumrowTax: sumrowTax
                            })).toBlob()
                        ];
                    case 1:
                        blob = _state.sent();
                        url = URL.createObjectURL(blob);
                        // เปิด PDF ในหน้าต่างใหม่
                        newWindow = window.open(url, "_blank");
                        // เตรียมปุ่มดาวน์โหลด
                        if (newWindow) {
                            fileName = "ใบแจ้งหนี้".concat(moment().format("YYYYMMDD_HHmm"), ".pdf");
                            // Inject ปุ่มดาวน์โหลดลงในแท็บใหม่
                            newWindow.document.write("\n        <html>\n          <head>\n            <title>".concat(fileName, '</title>\n          </head>\n          <body style="margin:0;">\n            <iframe src="').concat(url, '" width="100%" height="100%" style="border:none;"></iframe>\n          </body>\n        </html>\n        '));
                        } else {
                            alert("ไม่สามารถเปิดหน้าต่างใหม่ได้ กรุณาอนุญาต pop-up");
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function handleOpenPrint() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleDownload = function() {
        var _ref = _async_to_generator(function() {
            var blob, url, link;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            pdf(/*#__PURE__*/ _jsx(PagePrintPDF, {
                                data: dataPrint,
                                formData: formData,
                                partnerInfo: partnerInfo,
                                sumrowTotalNet: sumrowTotalNet,
                                sumDiscount: sumDiscount,
                                sumrowVat: sumrowVat,
                                sumrowTax: sumrowTax
                            })).toBlob()
                        ];
                    case 1:
                        blob = _state.sent();
                        url = URL.createObjectURL(blob);
                        link = document.createElement("a");
                        link.href = url;
                        link.download = "ใบแจ้งหนี้".concat(moment().format("YYYYMMDD_HHmm"), ".pdf"); // ตั้งชื่อไฟล์
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        URL.revokeObjectURL(url);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleDownload() {
            return _ref.apply(this, arguments);
        };
    }();
    var createBillingReducer = useAppSelector(function(state) {
        return state.createBillingReducer;
    });
    var updateBillingReducer = useAppSelector(function(state) {
        return state.updateBillingReducer;
    });
    useEffect(function() {
        setIsLoading(createBillingReducer.isFetching);
        if (createBillingReducer.data && !createBillingReducer.isError) {
            setTextsuccess("สร้างใบแจ้งหนี้");
            setModalsuccess(true);
            // setFormdisabled(true);
            dispatch(clearcreateBilling());
            navigate("/billing");
        }
    }, [
        createBillingReducer
    ]);
    useEffect(function() {
        setIsLoading(updateBillingReducer.isFetching);
        if (updateBillingReducer.data && !updateBillingReducer.isError) {
            setTextsuccess("สร้างใบแจ้งหนี้");
            setModalsuccess(true);
            // setFormdisabled(true);
            dispatch(clearupdateBilling());
            navigate("/billing");
        }
    }, [
        updateBillingReducer
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "pagezoom",
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "รายรับ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "/billing",
                                        className: "tc-7  text-decoration-none",
                                        children: "ใบแจ้งหนี้"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: !dataID ? "สร้างใบแจ้งหนี้" : "ใบแจ้งหนี้"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 mb-2",
                        children: !dataID ? "สร้างใบแจ้งหนี้" : "ใบแจ้งหนี้"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Formik, {
                enableReinitialize: true,
                initialValues: formdata,
                validationSchema: schema,
                validateOnMount: true,
                onSubmit: function(values) {
                    var formdataPayload = new FormData();
                    console.log("values", values);
                    if (!dataID) {
                        var createData = [];
                        productRow.map(function(ele) {
                            return createData.push({
                                bl_detail_amount: parseInt(ele.bl_detail_amount),
                                bl_detail_discount: parseFloat(ele.bl_detail_discount),
                                bl_detail_discountreal: parseFloat(ele.bl_detail_discountreal),
                                bl_detail_discounttype: parseInt(ele.bl_detail_discounttype),
                                bl_detail_name: ele.bl_detail_name,
                                bl_detail_net: parseFloat(ele.bl_detail_net),
                                bl_detail_price: parseFloat(ele.bl_detail_price),
                                bl_detail_pricediscount: parseFloat(ele.bl_detail_pricediscount),
                                bl_detail_remark: ele.bl_detail_remark,
                                bl_detail_tax: parseFloat(ele.bl_detail_tax),
                                bl_detail_taxtype: parseInt(ele.bl_detail_taxtype),
                                bl_detail_totalprice: parseFloat(ele.bl_detail_totalprice),
                                bl_detail_unit: ele.bl_detail_unit,
                                bl_detail_vat: parseFloat(ele.bl_detail_vat),
                                bl_detail_vatnet: parseFloat(ele.bl_detail_vatnet),
                                bl_detail_vatprice: parseFloat(ele.bl_detail_vatprice)
                            });
                        });
                        var createFile = [];
                        docPath.map(function(ele) {
                            return createFile.push({
                                bl_file_url: ele.bl_file_url
                            });
                        });
                        var dataForm = {
                            bl_billing_businessid: values.bl_billing_businessid,
                            bl_billing_quotid: values.bl_billing_quotid ? values.bl_billing_quotid : null,
                            bl_billing_status: values.bl_billing_status,
                            bl_billing_refercode: formData.bl_billing_refercode ? formData.bl_billing_refercode : "",
                            bl_billing_categoryid: values.bl_billing_categoryid ? values.bl_billing_categoryid : null,
                            bl_billing_suffixname: values.bl_billing_suffixname ? values.bl_billing_suffixname : "",
                            bl_billing_vatcode: values.bl_billing_vatcode ? values.bl_billing_vatcode : "",
                            bl_billing_name: values.bl_billing_name ? values.bl_billing_name : "",
                            bl_billing_address: values.bl_billing_address ? values.bl_billing_address : "",
                            bl_billing_fname: values.bl_billing_fname ? values.bl_billing_fname : "",
                            bl_billing_lname: values.bl_billing_lname ? values.bl_billing_lname : "",
                            bl_billing_mainfname: values.bl_billing_mainfname ? values.bl_billing_mainfname : "",
                            bl_billing_mainlname: values.bl_billing_mainlname ? values.bl_billing_mainlname : "",
                            bl_billing_mainphone: values.bl_billing_mainphone ? values.bl_billing_mainphone : "",
                            bl_billing_mainemail: values.bl_billing_mainemail ? values.bl_billing_mainemail : "",
                            bl_billing_provinceid: values.bl_billing_provinceid ? values.bl_billing_provinceid : null,
                            bl_billing_subprovinceid: values.bl_billing_subprovinceid ? values.bl_billing_subprovinceid : null,
                            bl_billing_zipcodeid: values.bl_billing_zipcodeid ? values.bl_billing_zipcodeid : null,
                            bl_billing_districtid: values.bl_billing_districtid ? values.bl_billing_districtid : null,
                            bl_billing_comprefixid: values.bl_billing_comprefixid ? values.bl_billing_comprefixid : null,
                            bl_billing_comprefixname: values.bl_billing_comprefixname ? values.bl_billing_comprefixname : "",
                            bl_billing_taxid: values.bl_billing_taxid ? values.bl_billing_taxid : "",
                            bl_billing_businesstype: values.bl_billing_businesstype ? values.bl_billing_businesstype : null,
                            bl_billing_branchname: values.bl_billing_branchname ? values.bl_billing_branchname : "",
                            bl_billing_memid: values.bl_billing_memid ? values.bl_billing_memid : null,
                            bl_billing_issuedate: formData.bl_billing_issuedate ? moment(docDate).format("YYYY-MM-DD") + "T00:00:00.000Z" : "",
                            bl_billing_expiredate: formData.bl_billing_expiredate ? moment(dueDate).format("YYYY-MM-DD") + "T00:00:00.000Z" : "",
                            bl_billing_ramark: remark,
                            bl_billing_tag: tagselected,
                            bl_billing_paytype: parseInt(formData.bl_billing_paytype),
                            bl_billing_vattype: parseInt(formData.bl_billing_vattype),
                            bl_billing_totalprice: parseFloat(sumrowNoDiscount),
                            bl_billing_discounttype: formData.bl_billing_discounttype,
                            bl_billing_discount: formData.bl_billing_discount ? parseFloat(formData.bl_billing_discount) : 0,
                            bl_billing_discountreal: parseFloat(sumDiscount),
                            bl_billing_pricediscount: parseFloat(sumrowBeforeVat),
                            bl_billing_vat: formData.bl_billing_vat ? formData.bl_billing_vat : 0,
                            bl_billing_totalvat: parseFloat(sumrowVat),
                            bl_billing_tax: formData.bl_billing_tax ? formData.bl_billing_tax : 0,
                            bl_billing_totaltax: parseFloat(sumrowTax),
                            bl_billing_totalnet: parseFloat(sumrowTotalNet - sumDiscount + sumrowVat - sumrowTax, 2),
                            bl_billing_totalpay: formData.bl_billing_totalpay ? formData.bl_billing_totalpay : 0,
                            bl_billing_totalbalance: formData.bl_billing_totalbalance ? formData.bl_billing_totalbalance : 0,
                            bl_billing_totalnetvat: parseFloat(sumrowTotalNet - sumDiscount + sumrowVat),
                            bldetailcreate: createData,
                            filecreate: createFile
                        };
                        console.log("dataFormCreate", dataForm);
                        dispatch(createBilling(dataForm, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                    } else {
                        var createData1 = [];
                        var updateData = [];
                        productRow.filter(function(v) {
                            return v.type == "create";
                        }).map(function(ele) {
                            return createData1.push({
                                bl_detail_amount: ele.bl_detail_amount ? parseInt(ele.bl_detail_amount) : null,
                                bl_detail_discount: parseFloat(ele.bl_detail_discount),
                                bl_detail_discountreal: parseFloat(ele.bl_detail_discountreal),
                                bl_detail_discounttype: parseInt(ele.bl_detail_discounttype),
                                bl_detail_name: ele.bl_detail_name,
                                bl_detail_net: ele.bl_detail_net ? parseFloat(ele.bl_detail_net) : null,
                                bl_detail_price: parseFloat(ele.bl_detail_price),
                                bl_detail_pricediscount: parseFloat(ele.bl_detail_pricediscount),
                                bl_detail_remark: ele.bl_detail_remark,
                                bl_detail_tax: parseFloat(ele.bl_detail_tax),
                                bl_detail_taxtype: parseInt(ele.bl_detail_taxtype),
                                bl_detail_totalprice: parseFloat(ele.bl_detail_totalprice),
                                bl_detail_unit: ele.bl_detail_unit,
                                bl_detail_vat: parseFloat(ele.bl_detail_vat),
                                bl_detail_vatnet: parseFloat(ele.bl_detail_vatnet),
                                bl_detail_vatprice: parseFloat(ele.bl_detail_vatprice)
                            });
                        });
                        productRow.filter(function(v) {
                            return v.type == "update";
                        }).map(function(ele) {
                            return updateData.push({
                                bl_detail_amount: parseInt(ele.bl_detail_amount),
                                bl_detail_discount: parseFloat(ele.bl_detail_discount),
                                bl_detail_discountreal: parseFloat(ele.bl_detail_discountreal),
                                bl_detail_discounttype: parseInt(ele.bl_detail_discounttype),
                                bl_detail_name: ele.bl_detail_name,
                                bl_detail_net: parseFloat(ele.bl_detail_net),
                                bl_detail_price: parseFloat(ele.bl_detail_price),
                                bl_detail_pricediscount: parseFloat(ele.bl_detail_pricediscount),
                                bl_detail_remark: ele.bl_detail_remark,
                                bl_detail_tax: parseFloat(ele.bl_detail_tax),
                                bl_detail_taxtype: parseInt(ele.bl_detail_taxtype),
                                bl_detail_totalprice: parseFloat(ele.bl_detail_totalprice),
                                bl_detail_unit: ele.bl_detail_unit,
                                bl_detail_vat: parseFloat(ele.bl_detail_vat),
                                bl_detail_vatnet: parseFloat(ele.bl_detail_vatnet),
                                bl_detail_vatprice: parseFloat(ele.bl_detail_vatprice),
                                bl_detail_id: ele.bl_detail_id
                            });
                        });
                        var createFile1 = [];
                        var updateFile = [];
                        docPath.filter(function(v) {
                            return v.type == "create";
                        }).map(function(ele) {
                            return createFile1.push({
                                bl_file_url: ele.bl_file_url
                            });
                        });
                        docPath.filter(function(v) {
                            return v.type == "update";
                        }).map(function(ele) {
                            return updateFile.push({
                                bl_file_id: ele.bl_file_id
                            });
                        });
                        var dataForm1 = {
                            bl_billing_businessid: values.bl_billing_businessid,
                            bl_billing_refercode: formData.bl_billing_refercode ? formData.bl_billing_refercode : "",
                            bl_billing_status: values.bl_billing_status,
                            bl_billing_categoryid: values.bl_billing_categoryid,
                            bl_billing_suffixname: values.bl_billing_suffixname,
                            bl_billing_vatcode: values.bl_billing_vatcode,
                            bl_billing_name: values.bl_billing_name,
                            bl_billing_address: values.bl_billing_address,
                            bl_billing_fname: values.bl_billing_fname,
                            bl_billing_lname: values.bl_billing_lname,
                            bl_billing_mainfname: values.bl_billing_mainfname,
                            bl_billing_mainlname: values.bl_billing_mainlname,
                            bl_billing_mainphone: values.bl_billing_mainphone,
                            bl_billing_mainemail: values.bl_billing_mainemail,
                            bl_billing_provinceid: values.bl_billing_provinceid,
                            bl_billing_subprovinceid: values.bl_billing_subprovinceid,
                            bl_billing_zipcodeid: values.bl_billing_zipcodeid,
                            bl_billing_districtid: values.bl_billing_districtid,
                            bl_billing_comprefixid: values.bl_billing_comprefixid,
                            bl_billing_comprefixname: values.bl_billing_comprefixname,
                            bl_billing_taxid: values.bl_billing_taxid,
                            bl_billing_businesstype: values.bl_billing_businesstype,
                            bl_billing_branchname: values.bl_billing_branchname,
                            bl_billing_memid: values.bl_billing_memid,
                            bl_billing_id: formData.bl_billing_id,
                            bl_billing_issuedate: formData.bl_billing_issuedate ? moment(docDate).format("YYYY-MM-DD") + "T00:00:00.000Z" : "",
                            bl_billing_expiredate: formData.bl_billing_expiredate ? moment(dueDate).format("YYYY-MM-DD") + "T00:00:00.000Z" : "",
                            bl_billing_ramark: remark,
                            bl_billing_tag: tagselected,
                            bl_billing_paytype: parseInt(formData.bl_billing_paytype),
                            bl_billing_vattype: parseInt(formData.bl_billing_vattype),
                            bl_billing_totalprice: parseFloat(sumrowNoDiscount),
                            bl_billing_discounttype: formData.bl_billing_discounttype ? formData.bl_billing_discounttype : 1,
                            bl_billing_discount: formData.bl_billing_discount ? parseFloat(formData.bl_billing_discount) : 0,
                            bl_billing_discountreal: parseFloat(sumDiscount),
                            bl_billing_pricediscount: parseFloat(sumrowBeforeVat),
                            bl_billing_vat: formData.bl_billing_vat ? formData.bl_billing_vat : 0,
                            bl_billing_totalvat: parseFloat(sumrowVat),
                            bl_billing_tax: formData.bl_billing_tax ? formData.bl_billing_tax : 0,
                            bl_billing_totaltax: parseFloat(sumrowTax),
                            bl_billing_totalnet: parseFloat(sumrowTotalNet - sumDiscount + sumrowVat - sumrowTax),
                            bl_billing_totalpay: formData.bl_billing_totalpay ? formData.bl_billing_totalpay : 0,
                            bl_billing_totalbalance: formData.bl_billing_totalbalance ? formData.bl_billing_totalbalance : 0,
                            bl_billing_totalnetvat: parseFloat(sumrowTotalNet - sumDiscount + sumrowVat),
                            bldetailcreate: createData1,
                            bldetailupdate: updateData,
                            bldetaildelete: productRowDel,
                            filecreate: createFile1,
                            fileupdate: updateFile,
                            filedelete: docPathDel
                        };
                        dispatch(updateBilling(dataForm1, {
                            modalObj: modalObj,
                            setModalObj: setModalObj
                        }));
                        console.log("update", dataForm1);
                    }
                },
                children: function(param) {
                    var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, setValues = param.setValues, isInvalid = param.isInvalid, isValid = param.isValid;
                    return /*#__PURE__*/ _jsxs(Form, {
                        noValidate: true,
                        onSubmit: function(e) {
                            e.preventDefault();
                            handleSubmit();
                        },
                        children: [
                            /*#__PURE__*/ _jsxs("fieldset", {
                                disabled: formdisabled,
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mx-auto mb-4 pb-3",
                                        children: /*#__PURE__*/ _jsx(StepperLabelWizard, {
                                            dataLabel: formData.bl_billing_status == 3 ? dataSteps2 : dataSteps1,
                                            activeStep: stepper
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "card card-st-3 mb-4",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "card-body px-xl-3",
                                            children: /*#__PURE__*/ _jsxs("div", {
                                                className: "pt-lg-3 px-lg-3",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-md-12 col-lg",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "เลขที่ใบแจ้งหนี้"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "bl_billing_code",
                                                                            value: formData.bl_billing_code,
                                                                            className: "form-control",
                                                                            placeholder: "IV-2410000001",
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-md-12 col-lg",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: [
                                                                                "วันที่ออกเอกสาร",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(DatePicker, {
                                                                            inputFormat: "DD/MM/YYYY",
                                                                            dateFormat: "dd/MM/yyyy",
                                                                            placeholderText: "วันที่ออกเอกสาร",
                                                                            selected: docDate,
                                                                            onChange: function(date) {
                                                                                setDocDate(date);
                                                                                setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                    bl_billing_issuedate: moment(date).format("DD/MM/YYYY")
                                                                                }));
                                                                            },
                                                                            disabled: formData.bl_billing_status == 1 ? false : true,
                                                                            className: "w-100 datepicker2",
                                                                            value: formData.bl_billing_issuedate
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-md-12 col-lg",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "วันที่ครบกำหนด"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(DatePicker, {
                                                                            inputFormat: "DD/MM/YYYY",
                                                                            dateFormat: "dd/MM/yyyy",
                                                                            placeholderText: "วันที่ครบกำหนด",
                                                                            selected: dueDate,
                                                                            onChange: function(date) {
                                                                                setDueDate(date);
                                                                                setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                    bl_billing_expiredate: moment(date).format("DD/MM/YYYY")
                                                                                }));
                                                                            },
                                                                            className: "w-100 datepicker2",
                                                                            disabled: formData.bl_billing_status == 1 ? false : true,
                                                                            value: formData.bl_billing_expiredate
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-md-12 col-lg",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "อ้างอิงระบบ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "bl_billing_refer",
                                                                            className: "form-control",
                                                                            placeholder: "อ้างอิงระบบ",
                                                                            value: formData.bl_billing_refer,
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-md-12 col-lg",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "อ้างอิง"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "bl_billing_refercode",
                                                                            className: "form-control",
                                                                            placeholder: "อ้างอิง",
                                                                            value: formData.bl_billing_refercode,
                                                                            onChange: function(e) {
                                                                                setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                    bl_billing_refercode: e.target.value
                                                                                })); // Update formData state
                                                                            },
                                                                            disabled: formData.bl_billing_status == 1 ? false : true
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-md-12 col-lg",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            style: {
                                                                                zIndex: 11
                                                                            },
                                                                            children: [
                                                                                "ผู้จัดจำหน่าย",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        formData.bl_billing_status == 1 ? /*#__PURE__*/ _jsx(ReactSearchAutocomplete, {
                                                                            items: supplierInfos,
                                                                            placeholder: "กรุณากรอกชื่อลูกค้า",
                                                                            onSelect: function(item) {
                                                                                setValues(_object_spread_props(_object_spread({}, values), {
                                                                                    bl_billing_memid: item.bus_business_memid ? item.bus_business_memid : values.bl_billing_memid,
                                                                                    bl_billing_businessid: item.bus_business_id ? item.bus_business_id : values.bl_billing_businessid,
                                                                                    bl_billing_businesstype: item.bus_business_businesstype ? item.bus_business_businesstype : values.bl_billing_businesstype,
                                                                                    bl_billing_taxid: item.bus_business_taxid ? item.bus_business_taxid : values.bl_billing_taxid,
                                                                                    bl_billing_categoryid: item.bus_business_categoryid ? item.bus_business_categoryid : values.bl_billing_categoryid,
                                                                                    bl_billing_comprefixname: item.bus_business_comprefixname ? item.bus_business_comprefixname : values.bl_billing_comprefixname,
                                                                                    bl_billing_name: item.bus_business_name ? item.bus_business_name : values.bl_billing_name,
                                                                                    bl_billing_suffixname: item.bus_business_suffixname ? item.bus_business_suffixname : values.bl_billing_suffixname,
                                                                                    bl_billing_vatcode: item.bus_business_vatcode ? item.bus_business_vatcode : values.bl_billing_vatcode,
                                                                                    bl_billing_branchname: item.bus_business_branchname ? item.bus_business_branchname : values.bl_billing_branchname,
                                                                                    bl_billing_prefixid: item.bus_business_prefixid ? item.bus_business_prefixid : values.bl_billing_prefixid,
                                                                                    bl_billing_fname: item.bus_business_fname ? item.bus_business_fname : values.bl_billing_fname,
                                                                                    bl_billing_lname: item.bus_business_lname ? item.bus_business_lname : values.bl_billing_lname,
                                                                                    bl_billing_address: item.bus_business_address ? item.bus_business_address : values.bl_billing_address,
                                                                                    bl_billing_provinceid: item.bus_business_provinceid ? item.bus_business_provinceid : values.bl_billing_provinceid,
                                                                                    bl_billing_subprovinceid: item.bus_business_subprovinceid ? item.bus_business_subprovinceid : values.bl_billing_subprovinceid,
                                                                                    bl_billing_districtid: item.bus_business_districtid ? item.bus_business_districtid : values.bl_billing_districtid,
                                                                                    bl_billing_zipcodeid: item.bus_business_zipcodeid ? item.bus_business_zipcodeid : values.bl_billing_zipcodeid,
                                                                                    bl_billing_mainfname: item.bus_business_mainfname ? item.bus_business_mainfname : values.bl_billing_mainfname,
                                                                                    bl_billing_mainlname: item.bus_business_mainlname ? item.bus_business_mainlname : values.bl_billing_mainlname,
                                                                                    bl_billing_mainphone: item.bus_business_mainphone ? item.bus_business_mainphone : values.bl_billing_mainphone,
                                                                                    bl_billing_mainemail: item.bus_business_mainemail ? item.bus_business_mainemail : values.bl_billing_mainemail
                                                                                }));
                                                                                setPartnerInfo(_object_spread_props(_object_spread({}, partnerInfo), {
                                                                                    companyName: item.bus_business_company,
                                                                                    companyBranch: item.bus_business_branchname && item.bus_business_branchname != "" && item.bus_business_branchname != null ? item.bus_business_branchname : "-",
                                                                                    companyTaxId: item.bus_business_taxid && item.bus_business_taxid != "" && item.bus_business_taxid != null ? item.bus_business_taxid : "-",
                                                                                    contractName: item.bus_business_mainfname && item.bus_business_mainfname != "" && item.bus_business_mainlname != null ? filterTextAndNum(item.bus_business_mainfname) + " " + filterTextAndNum(item.bus_business_mainlname) : "-",
                                                                                    companyAddress: item.bus_business_address && item.bus_business_address != "" && item.bus_business_address != null ? filterTextAndNum("".concat(item.bus_business_address)) : "",
                                                                                    companyProvince: item.bus_business_provinceid && item.bus_business_provinceid != "" && item.bus_business_provinceid != null ? JSON.parse(item.Busprovinceid.province_name).th : "",
                                                                                    companyDistrict: item.bus_business_subprovinceid && item.bus_business_subprovinceid != "" && item.bus_business_subprovinceid != null ? JSON.parse(item.Bussubprovinceid.district_name).th : "",
                                                                                    companySubDistrict: item.bus_business_districtid && item.bus_business_districtid != "" && item.bus_business_districtid != null ? JSON.parse(item.Busdistrictid.subdistrict_name).th : "",
                                                                                    companyZipCode: item.bus_business_zipcodeid && item.bus_business_zipcodeid != "" && item.bus_business_zipcodeid != null ? filterTextAndNum("".concat(item.bus_business_zipcodeid)) : "",
                                                                                    contactPhone: item.bus_business_mainphone && item.bus_business_mainphone != "" && item.bus_business_mainphone != null ? filterTextAndNum("".concat(item.bus_business_mainphone)) : "-",
                                                                                    contactEmail: item.bus_business_mainemail && item.bus_business_mainemail != "" && item.bus_business_mainemail != null ? filterTextAndNum("".concat(item.bus_business_mainemail)) : "-"
                                                                                }));
                                                                            },
                                                                            onClear: function() {
                                                                                setFieldValue("bl_billing_businessid", "");
                                                                                setPartnerInfo(_object_spread_props(_object_spread({}, partnerInfo), {
                                                                                    companyName: "",
                                                                                    companyBranch: "-",
                                                                                    companyTaxId: "-",
                                                                                    companyAddress: "",
                                                                                    companyProvince: "",
                                                                                    companyDistrict: "",
                                                                                    companySubDistrict: "",
                                                                                    companyZipCode: "",
                                                                                    contractName: "",
                                                                                    contactPhone: "-",
                                                                                    contactEmail: "-"
                                                                                }));
                                                                            },
                                                                            autoFocus: true,
                                                                            formatResult: formatResult,
                                                                            inputSearchString: partnerInfo.companyName ? partnerInfo.companyName : "",
                                                                            fuseOptions: {
                                                                                keys: [
                                                                                    "bus_business_company",
                                                                                    "bus_business_taxid"
                                                                                ]
                                                                            },
                                                                            resultStringKeyName: "bus_business_company",
                                                                            styling: {
                                                                                height: "50px",
                                                                                borderRadius: "10px",
                                                                                boxShadow: "none",
                                                                                zIndex: 10,
                                                                                border: !values.bl_billing_memid ? "1px solid #dc3545" : "1px solid rgb(223, 225, 229)"
                                                                            },
                                                                            showIcon: false,
                                                                            className: "scrollSearchAutocomplete",
                                                                            readOnly: true
                                                                        }) : /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "bl_billing_name",
                                                                            className: "form-control",
                                                                            placeholder: "กรุณากรอกชื่อลูกค้า",
                                                                            value: partnerInfo.companyName,
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-md-12 col-lg",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ประเภทราคา"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "bl_billing_vattype",
                                                                            onChange: function(e) {
                                                                                setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                    bl_billing_vattype: e.value
                                                                                }));
                                                                            },
                                                                            className: "w-100 select-st-1",
                                                                            options: optionsMstPriceType,
                                                                            placeholder: "เลือกประเภทราคา",
                                                                            value: optionsMstPriceType.filter(function(item) {
                                                                                return item.value === formData.bl_billing_vattype;
                                                                            }),
                                                                            isDisabled: formData.bl_billing_status == 1 ? false : true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-md-12 col-lg",
                                                                children: /*#__PURE__*/ _jsx(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "form-st-3 sm pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "ประเภทการชำระเงิน"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                as: "select",
                                                                                name: "bl_billing_paytype",
                                                                                className: "w-100 select-st-1",
                                                                                placeholder: "เลือกประเภทการชำระเงิน",
                                                                                options: optionsMstPaymentType,
                                                                                value: optionsMstPaymentType.filter(function(item) {
                                                                                    return item.value === formData.bl_billing_paytype;
                                                                                }),
                                                                                onChange: function(e) {
                                                                                    setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                        bl_billing_paytype: e.value
                                                                                    })); // Update formData state
                                                                                },
                                                                                isDisabled: formData.bl_billing_status == 1 ? false : true
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-md-12 col-lg",
                                                                children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-2 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Label, {
                                                                            className: "mb-1",
                                                                            children: "ผู้จัดทำเอกสาร"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "text",
                                                                            name: "creBy",
                                                                            className: "form-control",
                                                                            placeholder: "admim",
                                                                            value: adminInfo && adminInfo.userId && adminInfo.userId != "" && adminInfo.userId != null ? adminInfo.userFullName : "-",
                                                                            onChange: handleChange,
                                                                            disabled: true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-md-12 col-lg",
                                                                children: formData.bl_billing_status == 5 ? /*#__PURE__*/ _jsx("div", {
                                                                    className: "pt-4 fw-bold text-center tc-8 fs-24",
                                                                    children: formData.bl_billing_canceldate ? "ยกเลิกรายการแล้ว : ".concat(formData.bl_billing_canceldate) : ""
                                                                }) : /*#__PURE__*/ _jsx("div", {
                                                                    className: "pt-4 text-center text-success fs-18",
                                                                    children: formData.bl_billing_approvedate ? "วันที่อนุมัติ : ".concat(moment(formData.bl_billing_approvedate).format("DD/MM/YYYY")) : ""
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row gx-xl-4",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-md-12 col-lg-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pb-lg-4 pt-lg-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "fw-bold fs-18 mb-2",
                                                                            children: "ชื่อลูกค้า"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            children: partnerInfo.companyName && partnerInfo.companyName != "" ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("p", {
                                                                                        className: "fs-18 mb-2",
                                                                                        children: partnerInfo.companyName
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsxs("p", {
                                                                                        className: "fs-18 mb-2",
                                                                                        children: [
                                                                                            "สาขา : ",
                                                                                            partnerInfo.companyBranch
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsxs("p", {
                                                                                        className: "fs-18 mb-2",
                                                                                        children: [
                                                                                            "ทะเบียนนิติบุคคล :",
                                                                                            " ",
                                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                                className: "tc-5",
                                                                                                children: partnerInfo.companyTaxId
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }) : /*#__PURE__*/ _jsx("div", {
                                                                                className: "fs-18 mb-2",
                                                                                children: "-"
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-md-12 col-lg-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pb-lg-4 pt-lg-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "fw-bold fs-18 mb-2",
                                                                            children: "ที่อยู่"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                children: partnerInfo.companyAddress && partnerInfo.companyAddress != "" ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("p", {
                                                                                            className: "fs-18 mb-2",
                                                                                            children: partnerInfo.companyAddress
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx("p", {
                                                                                            className: "fs-18 mb-2",
                                                                                            children: partnerInfo.companySubDistrict + " " + partnerInfo.companyDistrict
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsx("p", {
                                                                                            className: "fs-18 mb-2",
                                                                                            children: partnerInfo.companyProvince + " " + partnerInfo.companyZipCode
                                                                                        })
                                                                                    ]
                                                                                }) : /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: "-"
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-md-12 col-lg-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pb-lg-4 pt-lg-3",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            className: "fw-bold fs-18 mb-2",
                                                                            children: "ข้อมูลผู้ติดต่อ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx("div", {
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                children: partnerInfo.contractName && partnerInfo.contractName != "" ? /*#__PURE__*/ _jsxs(_Fragment, {
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsxs("p", {
                                                                                            className: "fs-18 mb-2",
                                                                                            children: [
                                                                                                "ชื่อ : ",
                                                                                                partnerInfo.contractName
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs("p", {
                                                                                            className: "fs-18 mb-2",
                                                                                            children: [
                                                                                                "เบอร์โทรศัพท์ : ",
                                                                                                partnerInfo.contactPhone
                                                                                            ]
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs("p", {
                                                                                            className: "fs-18 mb-2",
                                                                                            children: [
                                                                                                "อีเมล : ",
                                                                                                partnerInfo.contactEmail
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }) : /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fs-18 mb-2",
                                                                                    children: "-"
                                                                                })
                                                                            })
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "pagezoom",
                                        children: /*#__PURE__*/ _jsxs(Nav, {
                                            variant: "pills",
                                            activeKey: tabStatus,
                                            onSelect: function(selectedKey) {
                                                return setTabStatus(selectedKey);
                                            },
                                            className: "mb-3 fs-14",
                                            children: [
                                                /*#__PURE__*/ _jsx(Nav.Item, {
                                                    children: /*#__PURE__*/ _jsx(Nav.Link, {
                                                        className: "tc-13 nav-danger",
                                                        eventKey: "1",
                                                        children: "ข้อมูลสินค้า"
                                                    })
                                                }),
                                                statusPage >= 3 && /*#__PURE__*/ _jsx(Nav.Item, {
                                                    children: /*#__PURE__*/ _jsx(Nav.Link, {
                                                        className: "tc-13 nav-danger",
                                                        eventKey: "2",
                                                        children: "การรับชำระ"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    tabStatus == 1 && /*#__PURE__*/ _jsx(ProductData, {
                                        formdisabled: formdisabled,
                                        productRow: productRow,
                                        setProductRow: setProductRow,
                                        values: values,
                                        errors: errors,
                                        setFieldValue: setFieldValue,
                                        handleChange: handleChange,
                                        optionsMstDiscountType: optionsMstDiscountType,
                                        sumrowNoDiscount: sumrowNoDiscount,
                                        setSumrowNoDiscount: setSumrowNoDiscount,
                                        sumrowQty: sumrowQty,
                                        setSumrowQty: setSumrowQty,
                                        sumrowPrice: sumrowPrice,
                                        setSumrowPrice: setSumrowPrice,
                                        sumrowDiscount: sumrowDiscount,
                                        setSumrowDiscount: setSumrowDiscount,
                                        sumrowBeforeVat: sumrowBeforeVat,
                                        setSumrowBeforeVat: setSumrowBeforeVat,
                                        sumrowTotalNet: sumrowTotalNet,
                                        setSumrowTotalNet: setSumrowTotalNet,
                                        sumDiscount: sumDiscount,
                                        setSumDiscount: setSumDiscount,
                                        sumrowVat: sumrowVat,
                                        setSumrowVat: setSumrowVat,
                                        sumrowTax: sumrowTax,
                                        setSumrowTax: setSumrowTax,
                                        columdisplay: columdisplay,
                                        dataID: dataID,
                                        setFormData: setFormData,
                                        formData: formData,
                                        tagselected: tagselected,
                                        setTagSelected: setTagSelected,
                                        setRemark: setRemark,
                                        docPath: docPath,
                                        setDocPath: setDocPath,
                                        docPathDel: docPathDel,
                                        setDocPathDel: setDocPathDel,
                                        setIsLoading: setIsLoading,
                                        setModalObj: setModalObj,
                                        modalObj: modalObj,
                                        remark: remark,
                                        productRowDel: productRowDel,
                                        setProductRowDel: setProductRowDel,
                                        optionsMstTax: optionsMstTax
                                    }),
                                    tabStatus == 2 && /*#__PURE__*/ _jsx("div", {
                                        className: "row gx-xl-4",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "col-12",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "card pagezoom card-st-3 mb-4",
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        className: "card-body px-xl-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "pt-3 px-3",
                                                                children: [
                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                        className: "row gx-xl-4",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-8",
                                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "fs-26 py-3 fw-bold",
                                                                                    children: [
                                                                                        "ข้อมูลการรับชำระใบแจ้งหนี้เลขที่",
                                                                                        " ",
                                                                                        formData.bl_billing_code ? formData.bl_billing_code : "-"
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsxs("div", {
                                                                                className: "col tc-6",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("div", {
                                                                                        children: "อ้างอิงเลขที่สัญญา"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx("div", {
                                                                                        className: "fs-20 pt-2",
                                                                                        children: formData.bl_billing_refercode ? formData.bl_billing_refercode : "-"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ _jsxs("div", {
                                                                                className: "col tc-6",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("div", {
                                                                                        children: "อ้างอิงใบเสนอราคา"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsx("div", {
                                                                                        className: "fs-20 pt-2",
                                                                                        children: formData.bl_billing_refer ? formData.bl_billing_refer : "-"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("hr", {
                                                                        className: "my-2",
                                                                        style: {
                                                                            opacity: 0.1
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "pt-3 px-3",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "row gx-xl-4",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "col-6 tc-6",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Stack, {
                                                                                    direction: "row",
                                                                                    justifyContent: "space-between",
                                                                                    className: "mb-2",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "fs-20 pt-2",
                                                                                            children: "มูลค่าเต็มใบแจ้งหนี้ :"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                                            className: "fs-20 pt-2",
                                                                                            children: [
                                                                                                NumberFormat(formData.bl_billing_totalnet, 2),
                                                                                                " ",
                                                                                                "บาท"
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs(Stack, {
                                                                                    direction: "row",
                                                                                    justifyContent: "space-between",
                                                                                    className: "mb-2",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "fs-20 pt-2",
                                                                                            children: "มูลค่าสุทธิที่ต้องชำระทั้งสิ้น :"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                                            className: "fs-20 pt-2",
                                                                                            style: {
                                                                                                color: "#2DC76D"
                                                                                            },
                                                                                            children: [
                                                                                                NumberFormat(formData.bl_billing_totalnet, 2),
                                                                                                " ",
                                                                                                "บาท"
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                            className: "col-6 pl-10",
                                                                            children: [
                                                                                /*#__PURE__*/ _jsxs(Stack, {
                                                                                    direction: "row",
                                                                                    justifyContent: "space-between",
                                                                                    className: "mb-3",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "fs-24 pt-2 pt-3 tc-6",
                                                                                            children: "มูลค่าที่รอชำระ"
                                                                                        }),
                                                                                        /*#__PURE__*/ _jsxs("div", {
                                                                                            className: "tc-5 fs-24",
                                                                                            style: {
                                                                                                background: "#F6E1E3",
                                                                                                padding: "12px 20px",
                                                                                                borderRadius: "8px",
                                                                                                fontWeight: 500,
                                                                                                paddingLeft: 80
                                                                                            },
                                                                                            children: [
                                                                                                NumberFormat(formData.bl_billing_totalnet, 2),
                                                                                                "บาท"
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ _jsxs(Stack, {
                                                                                    direction: "row",
                                                                                    justifyContent: "space-between",
                                                                                    className: "mb-2",
                                                                                    children: [
                                                                                        statusPage == 3 && /*#__PURE__*/ _jsxs("div", {
                                                                                            className: "fs-20 pt-2 tc-8",
                                                                                            children: [
                                                                                                "วันที่ครบกำหนด :",
                                                                                                " ",
                                                                                                formData.bl_billing_expiredate
                                                                                            ]
                                                                                        }),
                                                                                        statusPage == 3 && /*#__PURE__*/ _jsx(Button, {
                                                                                            className: "btn btn-dg",
                                                                                            style: {
                                                                                                fontSize: 20
                                                                                            },
                                                                                            onClick: function() {
                                                                                                return setModalPay(function(prev) {
                                                                                                    return _object_spread_props(_object_spread({}, prev), {
                                                                                                        open: true
                                                                                                    });
                                                                                                });
                                                                                            },
                                                                                            children: "ชำระเงิน"
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                formData.bl_billing_totalpay == formData.bl_billing_totalnet && /*#__PURE__*/ _jsxs(Stack, {
                                                                                    direction: "row",
                                                                                    justifyContent: "flex-end",
                                                                                    className: "mb-2",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(CheckCircleIcon, {
                                                                                            style: {
                                                                                                color: "#B00412",
                                                                                                fontSize: 35
                                                                                            }
                                                                                        }),
                                                                                        " ",
                                                                                        /*#__PURE__*/ _jsx("div", {
                                                                                            className: "fs-24 tc-8 fw-bold ml-2",
                                                                                            children: "ชำระเต็มจำนวน"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                }),
                                                invoice.length > 0 && /*#__PURE__*/ _jsx("div", {
                                                    className: "card pagezoom card-st-3 mb-4",
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        className: "card-body px-xl-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsxs("div", {
                                                                className: "pt-3 px-3",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "row gx-xl-4",
                                                                        children: /*#__PURE__*/ _jsx("div", {
                                                                            className: "col-12",
                                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                                className: "fs-20 fw-bold",
                                                                                children: "การรับชำระเงิน"
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("hr", {
                                                                        className: "my-2",
                                                                        style: {
                                                                            opacity: 0.1
                                                                        }
                                                                    })
                                                                ]
                                                            }),
                                                            payment.map(function(ele, i) {
                                                                return /*#__PURE__*/ _jsx("div", {
                                                                    className: "pt-3 px-3",
                                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                                        className: "row gx-xl-4",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-3",
                                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "fs-20 fw-bold pt-2",
                                                                                    children: [
                                                                                        /*#__PURE__*/ _jsx(CheckCircleIcon, {
                                                                                            style: {
                                                                                                color: "#B00412",
                                                                                                fontSize: 35
                                                                                            }
                                                                                        }),
                                                                                        " ",
                                                                                        "ชำระเงินครั้งที่ ",
                                                                                        i + 1,
                                                                                        " "
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-8",
                                                                                children: ele.inv_invoice_id != null && /*#__PURE__*/ _jsx("div", {
                                                                                    className: "fs-20 fw-bold pt-2",
                                                                                    children: /*#__PURE__*/ _jsxs(Link, {
                                                                                        className: " me-2",
                                                                                        to: "/invoice/edit/" + ele.inv_invoice_id,
                                                                                        children: [
                                                                                            "เลขที่ใบเสร็จ",
                                                                                            " ",
                                                                                            /*#__PURE__*/ _jsx("span", {
                                                                                                className: "tc-8",
                                                                                                children: ele.inv_invoice_code ? ele.inv_invoice_code : "-"
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ _jsxs("div", {
                                                                                className: "col-6 ",
                                                                                children: [
                                                                                    /*#__PURE__*/ _jsx("div", {
                                                                                        className: "fs-20 pt-3 tc-6",
                                                                                        children: "เงินสด"
                                                                                    }),
                                                                                    /*#__PURE__*/ _jsxs("div", {
                                                                                        className: "fs-20 pt-3 tc-6",
                                                                                        children: [
                                                                                            "วันที่ชำระเงิน",
                                                                                            " ",
                                                                                            moment(ele.inv_invoice_issuedate).format("DD/MM/YYYY")
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ _jsx("div", {
                                                                                className: "col-6",
                                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                                    className: "fs-20 tc-6 pt-3",
                                                                                    children: [
                                                                                        NumberFormat(ele.inv_invoice_totalnet, 2),
                                                                                        " ",
                                                                                        "บาท"
                                                                                    ]
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                }, i);
                                                            }),
                                                            /*#__PURE__*/ _jsx("hr", {
                                                                className: "my-4",
                                                                style: {
                                                                    opacity: 0.1
                                                                }
                                                            }),
                                                            /*#__PURE__*/ _jsx(Stack, {
                                                                direction: "row",
                                                                justifyContent: "flex-end",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "pt-3 px-3 mb-4",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx("span", {
                                                                            className: "fs-20 tc-6 me-5",
                                                                            children: "มูลค่าที่รับชำระ"
                                                                        }),
                                                                        /*#__PURE__*/ _jsxs("span", {
                                                                            className: "fs-24 tc-6 text-white py-3 pr-3",
                                                                            style: {
                                                                                background: "#B00412",
                                                                                borderRadius: 10,
                                                                                paddingLeft: 100
                                                                            },
                                                                            children: [
                                                                                NumberFormat(formData.bl_billing_totalpay, 2),
                                                                                " ",
                                                                                "บาท"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(ModalAllder, {
                                        modal: modalPay,
                                        setModal: setModalPay,
                                        htitle: "การรับชำระเงิน",
                                        hbtn: true,
                                        children: /*#__PURE__*/ _jsx(Payment, {
                                            values: values,
                                            payDate: payDate,
                                            setPayDate: setPayDate,
                                            setFieldValue: setFieldValue,
                                            payment: payment,
                                            setModal: setModalPay,
                                            setPayment: setPayment,
                                            taxSwitch: taxSwitch,
                                            formData: formData,
                                            setIsLoading: setIsLoading,
                                            setModalObj: setModalObj,
                                            modalObj: modalObj,
                                            setTextsuccess: setTextsuccess,
                                            setModalsuccess: setModalsuccess,
                                            setTaxSwitch: setTaxSwitch,
                                            dataID: dataID,
                                            setTabStatus: setTabStatus,
                                            optionsMstTax: optionsMstTax
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "card pagezoom card-st-3  mb-4",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "card-body px-xl-3 d-flex ",
                                    children: [
                                        /*#__PURE__*/ _jsxs(Button, {
                                            type: "button",
                                            className: "btn-st-8 fs-14 border-0 px-3 me-3",
                                            // onClick={handlePrint}
                                            onClick: function() {
                                                handleOpenPrint();
                                                handleDownload();
                                            },
                                            disabled: formData.bl_billing_status > 2 ? false : true,
                                            children: [
                                                /*#__PURE__*/ _jsx("i", {
                                                    className: "iprinter"
                                                }),
                                                "พิมพ์เอกสาร"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            onClick: function(e) {
                                                navigate("/billing");
                                            },
                                            className: "btn-st-6 me-3 btn ms-auto",
                                            children: "ย้อนกลับ"
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            type: "submit",
                                            onClick: function(e) {
                                                handleSubmit();
                                                e.preventDefault();
                                            },
                                            disabled: formData.bl_billing_status == 5 && true,
                                            className: "btn-st-3 me-3",
                                            children: formData.bl_billing_status < 2 ? "บันทึกร่าง" : "บันทึก"
                                        }),
                                        formData.bl_billing_status == 1 && /*#__PURE__*/ _jsx(ButtonGroup, {
                                            className: " btn-group-st-1 ",
                                            children: /*#__PURE__*/ _jsx(Button, {
                                                type: "submit",
                                                onClick: function(e) {
                                                    handleSubmit();
                                                    e.preventDefault();
                                                    setFieldValue("bl_billing_status", 2);
                                                },
                                                children: "ส่งอนุมัติ"
                                            })
                                        }),
                                        formData.bl_billing_status == 2 && /*#__PURE__*/ _jsxs("span", {
                                            children: [
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "submit",
                                                    className: "me-3 btn-st-8",
                                                    onClick: function(e) {
                                                        handleSubmit();
                                                        e.preventDefault();
                                                        setFieldValue("bl_billing_status", 3);
                                                    },
                                                    children: "อนุมัติ"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "submit",
                                                    className: "btn-st-v2",
                                                    onClick: function(e) {
                                                        handleSubmit();
                                                        e.preventDefault();
                                                        setFieldValue("bl_billing_status", 1);
                                                    },
                                                    children: "ไม่อนุมัติ"
                                                })
                                            ]
                                        }),
                                        formData.bl_billing_status > 2 && formData.bl_billing_status < 5 && /*#__PURE__*/ _jsx(Link, {
                                            className: "btn text-white",
                                            onClick: function() {
                                                setModalDel(function(prev) {
                                                    return _object_spread_props(_object_spread({}, prev), {
                                                        open: true
                                                    });
                                                });
                                            },
                                            style: {
                                                marginRight: 3,
                                                background: "#565DFF"
                                            },
                                            children: "ยกเลิกรายการ"
                                        })
                                    ]
                                })
                            })
                        ]
                    });
                }
            }),
            /*#__PURE__*/ _jsx(ModalAllder, {
                modal: modalDel,
                setModal: setModalDel,
                htitle: "ยกเลิกรายการ",
                hbtn: true,
                children: /*#__PURE__*/ _jsx(DelModel, {
                    setModal: setModalDel,
                    modal: modalDel,
                    setModalsuccess: setModalsuccess,
                    setTextsuccess: setTextsuccess,
                    setIsLoading: setIsLoading,
                    setModalObj: setModalObj,
                    modalObj: modalObj,
                    dataID: dataID
                })
            }),
            /*#__PURE__*/ _jsx(SuccessModal, {
                show: modalsuccess,
                onHide: function() {
                    return setModalsuccess(false);
                },
                textsuccess: textsuccess,
                navigate: navigate,
                direction: dataID ? null : "/product"
            })
        ]
    });
}
export function DelModel(param) {
    var modal = param.modal, setModal = param.setModal, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, dataID = param.dataID;
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var updateBillingCancelReducer = useAppSelector(function(state) {
        return state.updateBillingCancelReducer;
    });
    useEffect(function() {
        setIsLoading(updateBillingCancelReducer.isFetching);
        if (updateBillingCancelReducer.data && !updateBillingCancelReducer.isError) {
            setTextsuccess("ยกเลิกรายการสำเร็จ");
            setModalsuccess(true);
            dispatch(clearupdateBillingCancel());
            dispatch(getBillingByID(parseInt(dataID), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setModal(function(prev) {
                return _object_spread_props(_object_spread({}, prev), {
                    open: false
                });
            });
        }
    }, [
        updateBillingCancelReducer
    ]);
    var onClickModel = function() {
        if (dataID) {
            dispatch(updateBillingCancel(dataID, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "",
        children: /*#__PURE__*/ _jsxs("center", {
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "text-center fs-24 tc-5 my-4",
                    children: "คุณต้องการยกเลิกรายการนี้"
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "text-center mt-5",
                    children: [
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-st-6 me-3",
                            onClick: function() {
                                return setModal(function(prev) {
                                    return _object_spread_props(_object_spread({}, prev), {
                                        open: false
                                    });
                                });
                            },
                            children: "ยกเลิก"
                        }),
                        /*#__PURE__*/ _jsx("button", {
                            type: "button",
                            className: "btn btn-dg",
                            onClick: function(e) {
                                onClickModel();
                            },
                            children: "ยืนยัน"
                        })
                    ]
                })
            ]
        })
    });
}
function ProductData(param) {
    var formdisabled = param.formdisabled, productRow = param.productRow, setProductRow = param.setProductRow, values = param.values, optionsMstDiscountType = param.optionsMstDiscountType, sumrowTotalNet = param.sumrowTotalNet, setSumrowTotalNet = param.setSumrowTotalNet, sumDiscount = param.sumDiscount, setSumDiscount = param.setSumDiscount, setSumrowNoDiscount = param.setSumrowNoDiscount, sumrowNoDiscount = param.sumrowNoDiscount, sumrowQty = param.sumrowQty, setSumrowQty = param.setSumrowQty, sumrowPrice = param.sumrowPrice, setSumrowPrice = param.setSumrowPrice, sumrowDiscount = param.sumrowDiscount, setSumrowDiscount = param.setSumrowDiscount, sumrowBeforeVat = param.sumrowBeforeVat, setSumrowBeforeVat = param.setSumrowBeforeVat, sumrowVat = param.sumrowVat, setSumrowVat = param.setSumrowVat, sumrowTax = param.sumrowTax, setSumrowTax = param.setSumrowTax, columdisplay = param.columdisplay, dataID = param.dataID, setFormData = param.setFormData, formData = param.formData, setTagSelected = param.setTagSelected, setDocPathDel = param.setDocPathDel, docPathDel = param.docPathDel, tagselected = param.tagselected, remark = param.remark, setRemark = param.setRemark, docPath = param.docPath, setDocPath = param.setDocPath, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, productRowDel = param.productRowDel, setProductRowDel = param.setProductRowDel, optionsMstTax = param.optionsMstTax;
    var _useState = _sliced_to_array(useState(true), 2), collapse = _useState[0], setCollapse = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), customSort = _useState1[0], setCustomSort = _useState1[1];
    var _useState2 = _sliced_to_array(useState(0), 2), rowCount = _useState2[0], setRowCount = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), optionsWarehouse = _useState3[0], setOptionsWarehouse = _useState3[1];
    var dispatch = useAppDispatch();
    var _useState4 = _sliced_to_array(useState(""), 2), textImg = _useState4[0], setTextImg = _useState4[1];
    var handlePreviewFile = function(e) {
        if (e.target.files[0]) {
            var formData = new FormData();
            formData.append("upload_tmp_billing", e.target.files[0]);
            dispatch(uploadBilling(formData, {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setTextImg("doc");
        }
    };
    var uploadBillingReducer = useAppSelector(function(state) {
        return state.uploadBillingReducer;
    });
    useEffect(function() {
        if (textImg == "doc") {
            setIsLoading(uploadBillingReducer.isFetching);
            if (uploadBillingReducer.data) {
                console.log("uploadBillingReducer", uploadBillingReducer.data.data);
                setDocPath(function(prev) {
                    return _to_consumable_array(prev).concat([
                        {
                            id: nanoid(),
                            bl_file_url: uploadBillingReducer.data.data,
                            type: "create"
                        }
                    ]);
                });
                setTextImg("");
            }
        }
    }, [
        uploadBillingReducer
    ]);
    var deleteDocument = function(removeId, item) {
        setDocPath(function(doc) {
            return doc.filter(function(item) {
                return item.id !== removeId;
            });
        });
        if (item.type == "update") {
            var del = {
                bl_file_id: item.bl_file_id
            };
            setDocPathDel(_to_consumable_array(docPathDel).concat([
                del
            ]));
        }
    };
    var _useState5 = _sliced_to_array(useState({
        open: false,
        x: 10,
        y: 10,
        width: 1200,
        height: 500,
        pin: false,
        mode: "normal",
        modalname: "pr-product-select"
    }), 2), modal = _useState5[0], setModal = _useState5[1];
    var _useState6 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 450,
        pin: false,
        mode: "normal",
        modalname: "pr-product-sort"
    }), 2), modalSort = _useState6[0], setModalSort = _useState6[1];
    var _useState7 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 500,
        pin: false,
        mode: "normal",
        modalname: "pr-load-document"
    }), 2), modalLoadDocument = _useState7[0], setModalLoadDocument = _useState7[1];
    var _useState8 = _sliced_to_array(useState({
        open: false,
        x: 0,
        y: 0,
        width: 530,
        height: 570,
        pin: false,
        mode: "normal",
        modalname: "pr-product-display"
    }), 2), modalDisplayColumn = _useState8[0], setModalDisplayColumn = _useState8[1];
    var sensors = useSensors(useSensor(MouseSensor, {}), useSensor(TouchSensor, {}), useSensor(KeyboardSensor, {}));
    var optionsMstVat = [
        {
            value: 0,
            label: "-"
        },
        {
            value: 3,
            label: "3%"
        },
        {
            value: 7,
            label: "7%"
        },
        {
            value: 10,
            label: "10%"
        }
    ];
    var addProductRow = function(num) {
        for(var i = 0; i < num; i++){
            setProductRow(function(row) {
                return _to_consumable_array(row).concat([
                    {
                        rowID: nanoid(),
                        bl_detail_name: "",
                        bl_detail_unit: "",
                        bl_detail_amount: "",
                        bl_detail_price: 0,
                        bl_detail_discounttype: 1,
                        bl_detail_discount: 0,
                        bl_detail_discountreal: 0,
                        bl_detail_pricediscount: 0,
                        bl_detail_vat: 0,
                        bl_detail_vatprice: 0,
                        bl_detail_net: "",
                        bl_detail_remark: "",
                        is_checked: false,
                        bl_detail_totalprice: 0,
                        bl_detail_vatnet: 0,
                        bl_detail_taxtype: 0,
                        bl_detail_tax: 0,
                        type: "create"
                    }
                ]);
            });
        }
    };
    var sumQty = function(productRow) {
        var qty = 0;
        var price = 0;
        var priceAfterDiscount = 0;
        var priceVat = 0;
        var ums = 0;
        var discount = 0;
        var pricetax = 0;
        productRow.forEach(function(pd) {
            var productQty = parseFloat(pd.bl_detail_amount);
            var productPrice = parseFloat(pd.bl_detail_price);
            var productDiscount = parseFloat(pd.bl_detail_discount);
            var productVat = parseFloat(pd.bl_detail_vatprice);
            var productTax = parseFloat(pd.bl_detail_tax);
            var disType = parseFloat(pd.bl_detail_discounttype);
            var hasValidQty = productQty > 0;
            var hasValidPrice = productPrice > 0;
            // Calculate price and priceAfterDiscount if both quantity and price are valid
            if (hasValidQty) {
                qty += productQty;
            }
            if (hasValidPrice) {
                price += productPrice;
                discount += productDiscount;
            }
            if (hasValidQty && hasValidPrice) {
                ums += productPrice * productQty;
                var type = disType == 1 ? productDiscount : productPrice * productDiscount / 100 * productQty;
                priceAfterDiscount += productPrice * productQty - type;
                priceVat += productVat;
                pricetax += productTax;
            }
            setSumrowNoDiscount(ums);
            setSumrowQty(qty);
            setSumrowPrice(price);
            setSumrowDiscount(discount);
            setSumrowBeforeVat(priceAfterDiscount);
            setSumrowTotalNet(priceAfterDiscount);
            var discountAA = formData.bl_billing_discounttype == 1 ? formData.bl_billing_discount : priceAfterDiscount * formData.bl_billing_discount / 100;
            setSumDiscount(discountAA);
        });
    };
    useEffect(function() {
        sumQty(productRow);
    }, [
        productRow
    ]);
    useEffect(function() {
        if (productRow.length <= 0) {
            addProductRow(1);
        }
    }, []);
    var onDeleteProductRow = function(removeId, item) {
        setProductRow(function(doc) {
            return doc.filter(function(item) {
                return item.rowID !== removeId;
            });
        });
        if (item.type == "update") {
            var del = {
                bl_detail_id: item.bl_detail_id
            };
            setProductRowDel(_to_consumable_array(productRowDel).concat([
                del
            ]));
        }
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "pagezoom",
                style: {
                    overflowX: "auto",
                    maxWidth: "100%",
                    overflowY: "hidden",
                    paddingBottom: "20px"
                },
                children: /*#__PURE__*/ _jsx(DndContext, {
                    sensors: sensors,
                    collisionDetection: closestCenter,
                    modifiers: [
                        restrictToVerticalAxis
                    ],
                    children: /*#__PURE__*/ _jsx(SortableContext, {
                        items: productRow,
                        strategy: verticalListSortingStrategy,
                        children: /*#__PURE__*/ _jsxs("table", {
                            className: "column_resize_table table1 table-striped ",
                            children: [
                                /*#__PURE__*/ _jsx("thead", {
                                    children: /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "รายการ"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 200
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "หน่วย"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 100
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                className: "!bg-[#666CFF] !text-white",
                                                children: "จำนวน"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer !bg-[#666CFF] !text-white",
                                                minWidth: 5,
                                                defaultWidth: 100
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                className: "!bg-[#B00412] !text-white",
                                                children: "ราคา/หน่วย"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer !bg-[#B00412] !text-white",
                                                minWidth: 5,
                                                defaultWidth: 110
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "มูลค่าก่อนส่วนลด"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 100
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "ส่วนลด"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 120
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "ประเภทส่วนลด"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 120
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "มูลค่ารวมสุทธิ"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 100
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                children: "หมายเหตุ"
                                            }),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer",
                                                minWidth: 5,
                                                defaultWidth: 100
                                            }),
                                            /*#__PURE__*/ _jsx("th", {}),
                                            /*#__PURE__*/ _jsx(ColumnResizer, {
                                                className: "columnResizer"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("tbody", {
                                    children: productRow.map(function(item, index) {
                                        return /*#__PURE__*/ _jsx(Productrow, {
                                            item: item,
                                            index: index,
                                            setProductRow: setProductRow,
                                            columdisplay: columdisplay,
                                            customSort: customSort,
                                            rowCount: rowCount,
                                            addProductRow: addProductRow,
                                            optionsWarehouse: optionsWarehouse,
                                            optionsMstDiscountType: optionsMstDiscountType,
                                            optionsMstVat: optionsMstVat,
                                            optionsMstTax: optionsMstTax,
                                            setFormData: setFormData,
                                            formData: formData,
                                            values: values,
                                            onDeleteProductRow: onDeleteProductRow
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ _jsx("tfoot", {
                                    children: /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "prQty",
                                                    className: "form-control text-center",
                                                    placeholder: "",
                                                    value: NumberFormat(sumrowQty, 0),
                                                    disabled: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body "
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "prPrict",
                                                    className: "form-control text-center",
                                                    placeholder: "",
                                                    value: NumberFormat(sumrowPrice, 2),
                                                    disabled: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body "
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "prBeforeVat",
                                                    className: "form-control text-center",
                                                    placeholder: "",
                                                    value: NumberFormat(sumrowNoDiscount, 2),
                                                    disabled: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body "
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "prDiscount",
                                                    className: "form-control text-center",
                                                    placeholder: "",
                                                    value: NumberFormat(sumrowDiscount, 2),
                                                    disabled: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                children: /*#__PURE__*/ _jsx(Form.Control, {
                                                    type: "text",
                                                    name: "prTotalNet",
                                                    className: "form-control text-center",
                                                    placeholder: "",
                                                    value: NumberFormat(sumrowTotalNet, 2),
                                                    disabled: true
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body "
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            }),
                                            /*#__PURE__*/ _jsx("td", {}),
                                            /*#__PURE__*/ _jsx("td", {
                                                className: "column_resizer_body"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mb-3",
                children: /*#__PURE__*/ _jsxs("fieldset", {
                    disabled: formdisabled,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "mb-3",
                            children: /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn-st-3 fs-14 me-3 mt-2",
                                onClick: function() {
                                    return addProductRow(1);
                                },
                                disabled: formData.bl_billing_status == 1 ? false : true,
                                children: "เพิ่มแถว"
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "card card-st-3 mb-4",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "card-body px-xl-3",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "row",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "col-12 col-md-12 col-lg-3",
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    className: "fs-20 fw-bold",
                                                    children: "สรุปข้อมูล"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "col-12 col-md-12 col-lg-6",
                                                children: [
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row mb-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-7 col-lg-8 text-lg-end",
                                                                children: /*#__PURE__*/ _jsx("label", {
                                                                    className: "",
                                                                    children: "มูลค่าสินค้าก่อนส่วนลด"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3  col-lg-3 text-end",
                                                                children: /*#__PURE__*/ _jsx("label", {
                                                                    children: NumberFormat(sumrowTotalNet, 2)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-2 col-lg-1 pl-0 text-end",
                                                                children: /*#__PURE__*/ _jsx("label", {
                                                                    children: "บาท"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row mb-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-12 col-lg-4 text-lg-end",
                                                                children: /*#__PURE__*/ _jsx("label", {
                                                                    className: "pt-lg-1",
                                                                    children: "ส่วนลด"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-12 col-lg-4",
                                                                children: /*#__PURE__*/ _jsxs("div", {
                                                                    className: "d-flex align-items-center fs-14",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Form.Control, {
                                                                            type: "number",
                                                                            name: "bl_billing_discount",
                                                                            className: "form-control",
                                                                            placeholder: "",
                                                                            value: formData.bl_billing_discount,
                                                                            onChange: function(e) {
                                                                                setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                    bl_billing_discount: e.target.value
                                                                                }));
                                                                                var discount = formData.bl_billing_discounttype == 1 ? e.target.value : sumrowTotalNet * e.target.value / 100;
                                                                                setSumDiscount(discount);
                                                                                var total = sumrowTotalNet - discount;
                                                                                setSumrowTax(total * formData.bl_billing_tax / 100);
                                                                                setSumrowVat(total * formData.bl_billing_vat / 100);
                                                                            },
                                                                            // sumrowTotalNet
                                                                            style: {
                                                                                borderRight: 0,
                                                                                borderTopRightRadius: 0,
                                                                                borderBottomRightRadius: 0
                                                                            },
                                                                            disabled: formData.bl_billing_status == 1 ? sumrowTotalNet == 0 ? true : false : true
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Select, {
                                                                            as: "select",
                                                                            name: "bl_billing_discounttype",
                                                                            onChange: function(e) {
                                                                                setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                                    bl_billing_discounttype: e.value
                                                                                }));
                                                                                var type = e.value == 1 ? formData.bl_billing_discount : sumrowTotalNet * formData.bl_billing_discount / 100;
                                                                                var total = sumrowTotalNet - type;
                                                                                setSumDiscount(type);
                                                                                setSumrowTax(total * formData.bl_billing_tax / 100);
                                                                                setSumrowVat(total * formData.bl_billing_vat / 100);
                                                                            },
                                                                            className: "w-100  select-st-2",
                                                                            options: optionsMstDiscountType,
                                                                            placeholder: "",
                                                                            value: optionsMstDiscountType.filter(function(item) {
                                                                                return item.value === formData.bl_billing_discounttype;
                                                                            }),
                                                                            style: {
                                                                                borderLeft: 0,
                                                                                borderTopLeftRadius: 0,
                                                                                borderBottomLeftRadius: 0,
                                                                                width: "80px"
                                                                            },
                                                                            isDisabled: formData.bl_billing_status == 1 ? sumrowTotalNet == 0 ? true : false : true
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-10 col-lg-3 pr-0 pt-2",
                                                                children: /*#__PURE__*/ _jsx("input", {
                                                                    className: "form-control text-end",
                                                                    style: {
                                                                        borderBottomWidth: "1px"
                                                                    },
                                                                    readOnly: true,
                                                                    disabled: true,
                                                                    value: NumberFormat(sumDiscount, 2)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-2 col-lg-1 pl-0 pt-2 text-end",
                                                                children: /*#__PURE__*/ _jsx("label", {
                                                                    className: "pt-lg-1",
                                                                    children: "บาท"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row mb-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-7 col-lg-8 text-end",
                                                                children: /*#__PURE__*/ _jsx("label", {
                                                                    className: "",
                                                                    children: "มูลค่าสินค้าหลังหักส่วนลด"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3 col-lg-3 text-end",
                                                                children: /*#__PURE__*/ _jsx("label", {
                                                                    children: NumberFormat(sumrowTotalNet - sumDiscount, 2)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-2 col-lg-1 pl-0 text-end",
                                                                children: /*#__PURE__*/ _jsx("label", {
                                                                    children: "บาท"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row mb-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-12 col-lg-6 text-lg-end",
                                                                children: /*#__PURE__*/ _jsx("label", {
                                                                    className: "pt-lg-1",
                                                                    children: "ภาษีมูลค่าเพิ่ม"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-12 col-lg-2 pl-lg-0 pt-2",
                                                                children: /*#__PURE__*/ _jsx(Select, {
                                                                    as: "select",
                                                                    name: "bl_billing_vat",
                                                                    onChange: function(e) {
                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                            bl_billing_vat: e.value
                                                                        }));
                                                                        var total = sumrowTotalNet - sumDiscount;
                                                                        setSumrowVat(total * e.value / 100);
                                                                    },
                                                                    options: optionsMstVat,
                                                                    value: optionsMstVat.filter(function(item) {
                                                                        return item.value === formData.bl_billing_vat;
                                                                    }),
                                                                    isDisabled: formData.bl_billing_status == 1 ? false : true
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-10 col-lg-3 px-lg-0 pr-0 pt-2",
                                                                children: /*#__PURE__*/ _jsx("input", {
                                                                    className: "form-control text-end",
                                                                    style: {
                                                                        borderBottomWidth: "1px"
                                                                    },
                                                                    readOnly: true,
                                                                    disabled: true,
                                                                    value: NumberFormat(sumrowVat, 2)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-2 col-lg-1 pl-0 pt-3 text-end",
                                                                children: /*#__PURE__*/ _jsx("label", {
                                                                    className: "pt-lg-1",
                                                                    children: "บาท"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row mb-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-7 col-lg-8 pr-0 text-end",
                                                                children: /*#__PURE__*/ _jsx("label", {
                                                                    className: "",
                                                                    children: "มูลค่าสินค้ารวมภาษีมูลค่าเพิ่ม"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-3 col-lg-3 text-end",
                                                                children: /*#__PURE__*/ _jsx("label", {
                                                                    children: NumberFormat(sumrowTotalNet - sumDiscount + sumrowVat, 2)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-2 col-lg-1 pl-0 text-end",
                                                                children: /*#__PURE__*/ _jsx("label", {
                                                                    children: "บาท"
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "row mb-3",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-12 col-lg-6 text-lg-end",
                                                                children: /*#__PURE__*/ _jsx("label", {
                                                                    className: "pt-lg-1",
                                                                    children: "หัก ณ ที่จ่าย"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-12 col-lg-2 pl-lg-0 pt-2",
                                                                children: /*#__PURE__*/ _jsx(Select, {
                                                                    as: "select",
                                                                    name: "bl_billing_tax",
                                                                    onChange: function(e) {
                                                                        setFormData(_object_spread_props(_object_spread({}, formData), {
                                                                            bl_billing_tax: e.value
                                                                        }));
                                                                        var total = sumrowTotalNet - sumDiscount;
                                                                        setSumrowTax(total * e.value / 100);
                                                                    },
                                                                    options: optionsMstTax,
                                                                    value: optionsMstTax.filter(function(item) {
                                                                        return item.value === formData.bl_billing_tax;
                                                                    }),
                                                                    isDisabled: formData.bl_billing_status == 1 ? false : true
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-10 col-lg-3 px-lg-0 pr-0 pt-2",
                                                                children: /*#__PURE__*/ _jsx("input", {
                                                                    className: "form-control text-end",
                                                                    style: {
                                                                        borderBottomWidth: "1px"
                                                                    },
                                                                    readOnly: true,
                                                                    disabled: true,
                                                                    value: NumberFormat(sumrowTax, 2)
                                                                })
                                                            }),
                                                            /*#__PURE__*/ _jsx("div", {
                                                                className: "col-2 col-lg-1 pl-0 pt-2 text-end",
                                                                children: /*#__PURE__*/ _jsx("label", {
                                                                    className: "pt-lg-1",
                                                                    children: "บาท"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "col-12 col-md-12 col-lg-3",
                                                children: [
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "mb-3 mt-2 text-end",
                                                        children: "มูลค่าสุทธิรวม"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("div", {
                                                        className: "text-white text-end fs-24",
                                                        style: {
                                                            background: "#B00412",
                                                            padding: "12px 20px",
                                                            borderRadius: "8px"
                                                        },
                                                        children: [
                                                            NumberFormat(sumrowTotalNet - sumDiscount + sumrowVat - sumrowTax, 2),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "fs-14 ms-2",
                                                                children: "บาท"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    collapse ? /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx("hr", {
                                                className: "my-4",
                                                style: {
                                                    opacity: 0.1
                                                }
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "row",
                                                children: /*#__PURE__*/ _jsx("div", {
                                                    className: "col-12 col-lg-6",
                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                        className: "mb-3",
                                                        controlId: "exampleForm.ControlTextarea1",
                                                        children: [
                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "fw-bold fs-18",
                                                                children: "หมายเหตุ"
                                                            }),
                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                as: "textarea",
                                                                rows: 3,
                                                                value: remark,
                                                                disabled: formData.bl_billing_status == 1 ? false : true,
                                                                style: {
                                                                    backgroundColor: "rgb(255 255 255 / 12%)"
                                                                },
                                                                onChange: function(e) {
                                                                    return setRemark(e.target.value);
                                                                }
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("hr", {
                                                className: "my-4",
                                                style: {
                                                    opacity: 0.1
                                                }
                                            })
                                        ]
                                    }) : "",
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "d-flex justify-content-end align-items-center",
                                        children: [
                                            /*#__PURE__*/ _jsx("button", {
                                                type: "button",
                                                className: "btn btn-link",
                                                style: {
                                                    color: "#FF6B00"
                                                },
                                                onClick: function() {
                                                    setCollapse(false);
                                                },
                                                disabled: !collapse,
                                                children: "ย่อ"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                children: "/"
                                            }),
                                            /*#__PURE__*/ _jsx("button", {
                                                type: "button",
                                                className: "btn btn-link",
                                                style: {
                                                    color: "#FF6B00"
                                                },
                                                onClick: function() {
                                                    setCollapse(true);
                                                },
                                                disabled: collapse,
                                                children: "ขยาย"
                                            })
                                        ]
                                    }),
                                    collapse ? /*#__PURE__*/ _jsxs(_Fragment, {
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "fw-bold fs-18 mb-3",
                                                children: "ไฟล์แนบ"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "pb-4",
                                                children: [
                                                    /*#__PURE__*/ _jsx("button", {
                                                        type: "button",
                                                        className: "btn  btn-upload-file mb-4",
                                                        onClick: function(e) {
                                                            return document.getElementById("fileUpload").click();
                                                        },
                                                        children: "อัพโหลดไฟล์แนบ"
                                                    }),
                                                    /*#__PURE__*/ _jsx("input", {
                                                        type: "file",
                                                        name: "",
                                                        className: "fileUpload hide-input",
                                                        id: "fileUpload",
                                                        accept: ".pdf",
                                                        // disabled={
                                                        //   formData.bl_billing_status == 1 ? false : true
                                                        // }
                                                        onChange: function(e) {
                                                            handlePreviewFile(e);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx("div", {
                                                        className: "d-flex align-items-center flex-wrap",
                                                        children: docPath.map(function(item, index) {
                                                            return /*#__PURE__*/ _jsxs("div", {
                                                                className: "d-flex align-items-center me-3 mb-3",
                                                                children: [
                                                                    /*#__PURE__*/ _jsx("div", {
                                                                        className: "me-3",
                                                                        children: index + 1
                                                                    }),
                                                                    /*#__PURE__*/ _jsx(Link, {
                                                                        to: item.bl_file_url,
                                                                        children: /*#__PURE__*/ _jsx("div", {
                                                                            className: "docfile",
                                                                            children: /*#__PURE__*/ _jsx("span", {
                                                                                className: "icon pdf",
                                                                                children: item.bl_file_url.substring(68)
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ _jsx("button", {
                                                                        type: "button",
                                                                        className: "btn  btn-delete-file-cross ms-3",
                                                                        onClick: function(e) {
                                                                            return deleteDocument(item.id, item);
                                                                        }
                                                                    })
                                                                ]
                                                            }, index);
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : ""
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
export default function Productrow(_param) {
    var item = _param.item, index = _param.index, setProductRow = _param.setProductRow, columdisplay = _param.columdisplay, customSort = _param.customSort, rowCount = _param.rowCount, addProductRow = _param.addProductRow, values = _param.values, optionsWarehouse = _param.optionsWarehouse, optionsMstDiscountType = _param.optionsMstDiscountType, optionsMstVat = _param.optionsMstVat, optionsMstTax = _param.optionsMstTax, setSumrowQty = _param.setSumrowQty, dataID = _param.dataID, onDeleteProductRow = _param.onDeleteProductRow, setFormData = _param.setFormData, formData = _param.formData, props = _object_without_properties(_param, [
        "item",
        "index",
        "setProductRow",
        "columdisplay",
        "customSort",
        "rowCount",
        "addProductRow",
        "values",
        "optionsWarehouse",
        "optionsMstDiscountType",
        "optionsMstVat",
        "optionsMstTax",
        "setSumrowQty",
        "dataID",
        "onDeleteProductRow",
        "setFormData",
        "formData"
    ]);
    return /*#__PURE__*/ _jsxs("tr", {
        className: "",
        children: [
            /*#__PURE__*/ _jsx("td", {
                children: /*#__PURE__*/ _jsx("input", {
                    type: "text",
                    className: "form-control formv border-0 me-2",
                    disabled: formData.bl_billing_status == 1 ? false : true,
                    style: {
                        backgroundColor: "rgb(255 255 255 / 12%)"
                    },
                    value: item.bl_detail_name,
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        bl_detail_name: e.target.value
                                    });
                                }
                                return el;
                            });
                        });
                    }
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.bl_detail_name != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "text",
                    className: "form-control formv border-0 me-2",
                    value: item.bl_detail_unit,
                    disabled: formData.bl_billing_status == 1 ? false : true,
                    style: {
                        backgroundColor: "rgb(255 255 255 / 12%)"
                    },
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        bl_detail_unit: e.target.value
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "!bg-[#EDEDFF]",
                style: {
                    color: "#666CFF"
                },
                children: item.bl_detail_name != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "number",
                    disabled: formData.bl_billing_status == 1 ? false : true,
                    className: "form-control formv text-center border-0 me-2 !bg-[#EDEDFF]",
                    value: item.bl_detail_amount,
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    var disPrice = item.bl_detail_discounttype == 1 ? item.bl_detail_discount : item.bl_detail_price * item.bl_detail_discount / 100 * item.bl_detail_amount;
                                    var price = parseFloat(item.bl_detail_price * e.target.value - disPrice);
                                    console.log("priceamount", price);
                                    return _object_spread_props(_object_spread({}, el), {
                                        bl_detail_amount: parseInt(e.target.value),
                                        bl_detail_totalprice: parseFloat(item.bl_detail_price * e.target.value),
                                        bl_detail_net: parseFloat(price)
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body !bg-[#EDEDFF]"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "!bg-[#F6E1E3]",
                style: {
                    color: "#B00412"
                },
                children: item.bl_detail_name != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "number",
                    className: "form-control formv text-center border-0 me-2 !bg-[#F6E1E3]",
                    disabled: formData.bl_billing_status == 1 ? false : true,
                    value: item.bl_detail_price,
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    var disPrice = item.bl_detail_discounttype == 1 ? item.bl_detail_discount : e.target.value * item.bl_detail_discount / 100 * item.bl_detail_amount;
                                    var price = parseFloat(e.target.value * item.bl_detail_amount - disPrice);
                                    console.log("pricePrice", price);
                                    return _object_spread_props(_object_spread({}, el), {
                                        bl_detail_price: parseFloat(e.target.value),
                                        bl_detail_totalprice: parseFloat(e.target.value * item.bl_detail_amount),
                                        bl_detail_net: parseFloat(price)
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body !bg-[#F6E1E3]"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.bl_detail_name != "" ? NumberFormat(item.bl_detail_totalprice) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.bl_detail_name != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "number",
                    className: "form-control formv text-center border-0 me-2",
                    value: item.bl_detail_discount,
                    disabled: formData.bl_billing_status == 1 ? false : true,
                    style: {
                        backgroundColor: "rgb(255 255 255 / 12%)"
                    },
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    var disPrice = item.bl_detail_discounttype == 1 ? e.target.value : item.bl_detail_price * e.target.value / 100 * item.bl_detail_amount;
                                    var price = item.bl_detail_price * item.bl_detail_amount - disPrice;
                                    console.log("pricediscount", price);
                                    console.log("disPricediscount", disPrice);
                                    return _object_spread_props(_object_spread({}, el), {
                                        bl_detail_discount: parseFloat(e.target.value),
                                        bl_detail_discountreal: parseFloat(disPrice),
                                        bl_detail_pricediscount: parseFloat(price),
                                        bl_detail_net: parseFloat(price)
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.bl_detail_name != "" ? /*#__PURE__*/ _jsxs("select", {
                    value: item.bl_detail_discounttype,
                    disabled: formData.bl_billing_status == 1 ? false : true,
                    style: {
                        width: "100%",
                        border: "0px solid rgb(223, 225, 229)",
                        backgroundColor: "rgb(255 255 255 / 12%)"
                    },
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    var disPrice = e.currentTarget.value == 1 ? item.bl_detail_discount : item.bl_detail_price * item.bl_detail_discount / 100 * item.bl_detail_amount;
                                    var price = item.bl_detail_price * item.bl_detail_amount - disPrice;
                                    console.log("pricetype", price);
                                    console.log("disPricetype", disPrice);
                                    return _object_spread_props(_object_spread({}, el), {
                                        bl_detail_discounttype: parseInt(e.currentTarget.value),
                                        bl_detail_discountreal: parseFloat(disPrice),
                                        bl_detail_pricediscount: parseFloat(price),
                                        bl_detail_net: parseFloat(price)
                                    });
                                }
                                return el;
                            });
                        });
                    },
                    className: "form-control sselectv",
                    children: [
                        /*#__PURE__*/ _jsx("option", {
                            value: "",
                            disabled: true,
                            children: "เลือกส่วนลด"
                        }, "default"),
                        optionsMstDiscountType && optionsMstDiscountType.map(function(v, index) {
                            return /*#__PURE__*/ _jsx("option", {
                                value: v.value,
                                children: v.label
                            }, index);
                        })
                    ]
                }) : "-"
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.bl_detail_name != "" ? NumberFormat(item.bl_detail_net) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                children: item.bl_detail_name != "" ? /*#__PURE__*/ _jsx("input", {
                    type: "text",
                    className: "form-control formv text-center border-0 me-2",
                    value: item.bl_detail_remark,
                    disabled: formData.bl_billing_status == 1 ? false : true,
                    style: {
                        backgroundColor: "rgb(255 255 255 / 12%)"
                    },
                    onChange: function(e) {
                        setProductRow(function(prev) {
                            return prev.map(function(el) {
                                if (el.rowID === item.rowID) {
                                    return _object_spread_props(_object_spread({}, el), {
                                        bl_detail_remark: e.target.value
                                    });
                                }
                                return el;
                            });
                        });
                    }
                }) : ""
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            }),
            /*#__PURE__*/ _jsx("td", {
                style: {
                    width: "20px"
                },
                children: /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    className: "btn btn-delete-file ",
                    onClick: function(e) {
                        return onDeleteProductRow(item.rowID, item);
                    },
                    disabled: formData.bl_billing_status == 1 ? false : true
                })
            }),
            /*#__PURE__*/ _jsx("td", {
                className: "column_resizer_body"
            })
        ]
    });
}
export function Payment(param) {
    var setPayDate = param.setPayDate, payDate = param.payDate, values = param.values, setFieldValue = param.setFieldValue, setPayment = param.setPayment, payment = param.payment, taxSwitch = param.taxSwitch, formData = param.formData, setIsLoading = param.setIsLoading, setModalObj = param.setModalObj, modalObj = param.modalObj, setTextsuccess = param.setTextsuccess, setModalsuccess = param.setModalsuccess, setTaxSwitch = param.setTaxSwitch, setModal = param.setModal, dataID = param.dataID, setTabStatus = param.setTabStatus, optionsMstTax = param.optionsMstTax;
    var dispatch = useAppDispatch();
    var createbybillingReducer = useAppSelector(function(state) {
        return state.createbybillingReducer;
    });
    useEffect(function() {
        setIsLoading(createbybillingReducer.isFetching);
        if (createbybillingReducer.data && !createbybillingReducer.isError) {
            setTextsuccess("ชำระเงินเต็มจำนวน");
            setModalsuccess(true);
            dispatch(clearcreateBilling());
            setModal(false);
            // navigate("/billing");
            dispatch(getBillingByID(parseInt(dataID), {
                modalObj: modalObj,
                setModalObj: setModalObj
            }));
            setTabStatus(2);
        }
    }, [
        createbybillingReducer
    ]);
    var optionsMstPayment = [
        {
            value: 1,
            label: "เงินสด"
        },
        {
            value: 2,
            label: "โอนธนาคาร"
        },
        {
            value: 3,
            label: ""
        }
    ];
    var onClickModelPay = function() {
        var data = {
            bl_billing_id: parseInt(dataID),
            inv_invoice_issuedate: moment(payDate).format("YYYY-MM-DD") + "T00:00:00.000Z",
            inv_invoice_paytype: payment[0].inv_invoice_paytype,
            inv_invoice_ramark: payment[0].inv_invoice_ramark,
            inv_invoice_taxstatus: taxSwitch == true ? 1 : 2,
            inv_invoice_totalnet: payment[0].inv_invoice_totalnet
        };
        console.log("data", data);
        dispatch(createbybilling(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "px-3 !bg-[rgb(176 3 18)]",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "row gx-xl-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-9",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "fs-24 fw-bold pt-3",
                            children: [
                                "รับชำะเงิน ",
                                formData.bl_billing_code
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-3",
                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "mb-3 form-st-3 pb-1",
                            children: [
                                /*#__PURE__*/ _jsx(Form.Label, {
                                    className: "mb-1",
                                    children: "วันที่ออกเอกสาร "
                                }),
                                /*#__PURE__*/ _jsx(DatePicker, {
                                    inputFormat: "DD/MM/YYYY",
                                    disabled: true,
                                    selected: payDate,
                                    onChange: function(date) {
                                        setPayDate(date);
                                    },
                                    placeholder: "DD/MM/YYYY",
                                    className: "w-100 datepicker2",
                                    value: payDate ? moment(payDate).format("DD/MM/YYYY") : moment().format("DD/MM/YYYY")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("hr", {
                className: "my-2",
                style: {
                    opacity: 0.1
                }
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "row gx-xl-4",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "col-12 mb-3",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "fs-24 tc-5 fw-bold",
                        children: "รายการชำระเงิน"
                    })
                })
            }),
            payment.map(function(item, index) {
                return /*#__PURE__*/ _jsxs("div", {
                    className: "row gx-xl-4",
                    keys: index,
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-xl-4 col-md-4",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "row",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-md-1",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "fs-20 fw-bold pt-3",
                                            children: [
                                                index + 1,
                                                "."
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-md-11",
                                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                                            className: "mb-2 form-st-3 pb-1",
                                            children: [
                                                /*#__PURE__*/ _jsx(Form.Label, {
                                                    className: "mb-1",
                                                    children: "เอกสาร"
                                                }),
                                                /*#__PURE__*/ _jsx(Select, {
                                                    as: "select",
                                                    placeholder: "เลือกเอกสาร",
                                                    name: "inv_invoice_paytype",
                                                    onChange: function(e) {
                                                        setPayment(function(prev) {
                                                            return prev.map(function(el) {
                                                                return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                                    inv_invoice_paytype: e.value
                                                                }) : el;
                                                            });
                                                        });
                                                    },
                                                    className: "w-100 select-st-1",
                                                    options: optionsMstPayment,
                                                    value: optionsMstPayment.filter(function(d) {
                                                        return d.value == item.inv_invoice_paytype;
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-xl-3 col-md-3",
                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                className: "form-st-3",
                                children: [
                                    /*#__PURE__*/ _jsx(Form.Label, {
                                        className: "mb-1",
                                        children: "จำนวนเงินที่ชำระ"
                                    }),
                                    /*#__PURE__*/ _jsx(Form.Control, {
                                        type: "text",
                                        name: "inv_invoice_totalnet",
                                        className: "form-control",
                                        placeholder: "จำนวนเงินที่ชำระ",
                                        value: NumberFormat(item.inv_invoice_totalnet, 2),
                                        disabled: true,
                                        onChange: function(e) {
                                            setPayment(function(prev) {
                                                return prev.map(function(el) {
                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                        inv_invoice_totalnet: e.target.value
                                                    }) : el;
                                                });
                                            });
                                        }
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "col-xl-4 col-md-4",
                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                className: "form-st-3",
                                children: [
                                    /*#__PURE__*/ _jsx(Form.Label, {
                                        className: "mb-1",
                                        children: "หมายเหตุ"
                                    }),
                                    /*#__PURE__*/ _jsx(Form.Control, {
                                        type: "text",
                                        name: "inv_invoice_ramark",
                                        className: "form-control",
                                        placeholder: "หมายเหตุ",
                                        value: item.inv_invoice_ramark,
                                        onChange: function(e) {
                                            setPayment(function(prev) {
                                                return prev.map(function(el) {
                                                    return el.id == item.id ? _object_spread_props(_object_spread({}, el), {
                                                        inv_invoice_ramark: e.target.value
                                                    }) : el;
                                                });
                                            });
                                        }
                                    })
                                ]
                            })
                        })
                    ]
                });
            }),
            /*#__PURE__*/ _jsx("hr", {
                className: "my-4",
                style: {
                    opacity: 0.1
                }
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row gx-xl-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-3 col-md-11",
                        children: /*#__PURE__*/ _jsxs(Stack, {
                            direction: "row",
                            justifyContent: "space-between",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "fs-24 fw-bold tc-5 mb-3",
                                    children: "หัก ณ ที่จ่าย"
                                }),
                                /*#__PURE__*/ _jsx(Form.Group, {
                                    children: /*#__PURE__*/ _jsx(FormControlLabel, {
                                        control: // <Switch
                                        //   defaultChecked={taxSwitch}
                                        //   onChange={(e) => {
                                        //     setTaxSwitch(taxSwitch == true ? false : true); // Update formData state
                                        //   }}
                                        // />
                                        /*#__PURE__*/ _jsx(Switch, {
                                            onChange: function(e) {
                                                if (e.target.checked) {
                                                    setTaxSwitch(true);
                                                // setFieldValue("isExpenses", 1);
                                                } else {
                                                    setTaxSwitch(false);
                                                // setFieldValue("isExpenses", 0);
                                                }
                                            },
                                            checked: taxSwitch == true
                                        }),
                                        label: ""
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-9 col-md-1"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-3 col-md-12",
                        children: /*#__PURE__*/ _jsx(Form.Group, {
                            className: "mb-2 form-st-3 pb-1",
                            children: /*#__PURE__*/ _jsxs(Form.Group, {
                                className: "form-st-3 sm pb-1",
                                children: [
                                    /*#__PURE__*/ _jsx(Form.Label, {
                                        className: "mb-1",
                                        children: "อัตตราภาษี"
                                    }),
                                    /*#__PURE__*/ _jsx(Select, {
                                        as: "select",
                                        name: "pd_product_vat",
                                        className: "w-100 select-st-1",
                                        placeholder: "เลือกอัตตราภาษี",
                                        options: optionsMstTax,
                                        value: optionsMstTax.filter(function(item) {
                                            return item.value === formData.bl_billing_tax;
                                        }),
                                        isDisabled: true
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-3 col-md-12",
                        children: /*#__PURE__*/ _jsxs(Form.Group, {
                            className: "mb-2 form-st-3 pb-1",
                            children: [
                                /*#__PURE__*/ _jsx(Form.Label, {
                                    className: "mb-1",
                                    children: "มูลค่าถูกหัก ณ ที่จ่าย"
                                }),
                                /*#__PURE__*/ _jsx(Form.Control, {
                                    type: "text",
                                    className: "form-control",
                                    placeholder: "มูลค่าถูกหัก ณ ที่จ่าย",
                                    value: NumberFormat(formData.bl_billing_totaltax ? formData.bl_billing_totaltax : 0, 2),
                                    disabled: true
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "fs-16 tc-5",
                        children: "หมายเหตุ: แสดงหน้าพิมพ์เอกสารใบเสร็จ"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("hr", {
                className: "my-4",
                style: {
                    opacity: 0.1
                }
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "row gx-xl-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-5 col-md-1"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-3 col-md-1"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "col-xl-4 col-md-1",
                        children: /*#__PURE__*/ _jsx(Stack, {
                            direction: "row",
                            justifyContent: "flex-end",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "tc-6 text-white py-3 px-3 !bg-[#B00412] mt-2",
                                style: {
                                    borderRadius: 10
                                },
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "fs-20 me-10",
                                        children: "รับชำระเงินรวมทั้งสิน"
                                    }),
                                    /*#__PURE__*/ _jsxs("span", {
                                        className: "fs-24 ",
                                        children: [
                                            NumberFormat(formData.bl_billing_totalnet ? formData.bl_billing_totalnet : 0, 2),
                                            " ",
                                            "บาท"
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "row gx-xl-4",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "col-xl-12 col-md-12",
                    children: /*#__PURE__*/ _jsxs(Stack, {
                        direction: "row",
                        justifyContent: "flex-end",
                        className: "mt-4",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn-st-6 me-3 btn py-1 px-5 mt-4",
                                style: {
                                    height: " 50px"
                                },
                                onClick: function(e) {
                                    onClickModelPay();
                                },
                                children: "ยกเลิก"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "mt-4 btn btn-dg",
                                onClick: function(e) {
                                    onClickModelPay();
                                },
                                children: "ยืนยันชำระเงิน"
                            })
                        ]
                    })
                })
            })
        ]
    });
}
export function PRPrint(param) {
    var innerRef = param.innerRef, dataPrint = param.dataPrint, formData = param.formData, partnerInfo = param.partnerInfo, sumrowTotalNet = param.sumrowTotalNet, sumDiscount = param.sumDiscount, sumrowVat = param.sumrowVat, sumrowTax = param.sumrowTax;
    return /*#__PURE__*/ _jsx("div", {
        ref: innerRef,
        children: /*#__PURE__*/ _jsx(PagePrint, {
            data: dataPrint,
            partnerInfo: partnerInfo,
            formData: formData,
            sumrowTotalNet: sumrowTotalNet,
            sumDiscount: sumDiscount,
            sumrowVat: sumrowVat,
            sumrowTax: sumrowTax
        })
    });
}
var PagePrint = function(param) {
    var data = param.data, partnerInfo = param.partnerInfo, sumrowTotalNet = param.sumrowTotalNet, formData = param.formData, sumDiscount = param.sumDiscount, sumrowVat = param.sumrowVat, sumrowTax = param.sumrowTax;
    var _data_BlDetail, _data_BlDetail1, _data_BlDetail2, _data_BlDetail3, _data_BlDetail4, _data_BlDetail5, _data_BlDetail6, _data_BlDetail7;
    var discounttype = formData.bl_billing_discounttype ? formData.bl_billing_discounttype : 1;
    var discount = formData.bl_billing_discount ? formData.bl_billing_discount : 0;
    var totalnet = formData.bl_billing_totalnet ? formData.bl_billing_totalnet : 0;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "text-[12.5px] text-[#2C2C2C] mb-1",
                style: {
                    width: "210mm",
                    height: "297mm",
                    padding: "5px 30px",
                    margin: "0",
                    background: "white",
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "row gx-xl-4",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-6",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "mt-3",
                                    children: /*#__PURE__*/ _jsx("img", {
                                        src: "/images/logopardesco.png",
                                        className: "w-[100px]"
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-6 text-end",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "mt-3",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "ml-5",
                                            children: "(ต้นฉบับ)"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "fs-18 text-danger fw-bold",
                                            children: "ใบแจ้งหนี้"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-end mt-2",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[20px]",
                                style: {
                                    borderBottom: "1px solid #909090"
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[40px]",
                                                children: "ผู้ขาย :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[250px]",
                                                children: "บริษัท พาร์เดสโก้ กรุ๊ป จำกัด (สำนักงานใหญ่ )"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[40px]",
                                                children: "ที่อยู่ :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[250px]",
                                                children: "241/54 ซอยกาญจนาภิเษก 0015 แขวงศาลาธรรมสพน์ เขตทวีวัฒนา กรุงเทพ 10170"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[130px]",
                                                children: "เลขประจำตัวผู้เสียภาษี :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[150px]",
                                                children: "0105568029236"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[60px]"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[250px]"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[20px]",
                                style: {
                                    borderBottom: "1px solid #909090"
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[40px]",
                                                children: "ติดต่อ :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[100px]",
                                                children: "วริธร สวยงาม"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(PhoneIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[100px]",
                                                children: "094-928-0297"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(EmailIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[100px]",
                                                children: "-"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(LanguageIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[100px]",
                                                children: "-"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[20px] px-2 pt-2",
                                style: {
                                    background: "#F6E1E3",
                                    borderRadius: 5
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[100px]",
                                                children: "เลขที่เอกสาร :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[80px]",
                                                children: data.bl_billing_code
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[100px]",
                                                children: "วันที่ออกเอกสาร :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[80px]",
                                                children: moment(data.bl_billing_issuedate).format("DD/MM/YYYY")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[100px]",
                                                children: "วันที่ครบกำหนด :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[80px]",
                                                children: moment(data.bl_billing_expiredate).format("DD/MM/YYYY")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex flex-end mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[100px]",
                                                children: "อ้างอิง :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[80px]",
                                                children: data.QrQuotation ? data.QrQuotation.qr_quotation_code : "-"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-end mt-2",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[20px]",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[40px]",
                                                children: "ลูกค้า :"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "grow text-[#000] w-[250px]",
                                                children: [
                                                    partnerInfo.companyName,
                                                    " ",
                                                    partnerInfo.companyBranch ? "(สาขา".concat(partnerInfo.companyBranch, ")") : ""
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[40px]",
                                                children: "ที่อยู่ :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[250px]",
                                                children: /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("p", {
                                                            children: [
                                                                partnerInfo.companyAddress + " " + partnerInfo.companySubDistrict,
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx("p", {
                                                            children: partnerInfo.companyDistrict + " " + partnerInfo.companyProvince + " " + partnerInfo.companyZipCode
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[130px]",
                                                children: "เลขประจำตัวผู้เสียภาษี :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[150px]",
                                                children: partnerInfo.companyTaxId ? partnerInfo.companyTaxId : "-"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[70px]"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[250px]"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[20px]",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[50px]",
                                                children: "ผู้ติดต่อ :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[220px]",
                                                children: partnerInfo.contractName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(PhoneIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[220px]",
                                                children: partnerInfo.contactPhone
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(EmailIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[220px]",
                                                children: partnerInfo.contactEmail
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(LanguageIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[220px]",
                                                children: "-"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "grow pr-[20px] px-2 pt-2",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[100px]"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000]"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "py-1",
                        children: /*#__PURE__*/ _jsxs("table", {
                            className: "w-full table-print",
                            children: [
                                /*#__PURE__*/ _jsx("thead", {
                                    style: {
                                        background: "#F6E1E3",
                                        borderRadius: 2,
                                        borderColor: "#F6E1E3"
                                    },
                                    children: /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("th", {
                                                valign: "middle",
                                                width: "6%",
                                                style: {
                                                    width: "6%"
                                                },
                                                className: "border-x border-y  text-center font-normal",
                                                children: "รายการ"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                valign: "middle",
                                                width: "2%",
                                                style: {
                                                    width: "2%"
                                                },
                                                className: "border-x border-y  text-center font-normal",
                                                children: "จำนวน"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                valign: "middle",
                                                width: "2%",
                                                style: {
                                                    width: "2%"
                                                },
                                                className: "border-x border-y  text-center font-normal",
                                                children: "ราคาต่อหน่วย"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                valign: "middle",
                                                width: "2%",
                                                style: {
                                                    width: "2%"
                                                },
                                                className: "border-x border-y  text-center font-normal",
                                                children: "ส่วนลด"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                valign: "middle",
                                                width: "2%",
                                                style: {
                                                    width: "2%"
                                                },
                                                className: "border-x border-y  text-center font-normal",
                                                children: "ราคารวม"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("tbody", {
                                    children: data === null || data === void 0 ? void 0 : (_data_BlDetail = data.BlDetail) === null || _data_BlDetail === void 0 ? void 0 : _data_BlDetail.map(function(ele, i) {
                                        return /*#__PURE__*/ _jsxs("tr", {
                                            style: {
                                                height: "30px"
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsxs("td", {
                                                    className: "border-x ellipsis",
                                                    style: {
                                                        borderColor: "#FFF"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx("p", {
                                                            children: "".concat(i + 1, ". ").concat(ele.bl_detail_name)
                                                        }),
                                                        /*#__PURE__*/ _jsx("p", {
                                                            children: "".concat(ele.bl_detail_remark ? "(" + ele.bl_detail_remark + ")" : "")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "border-x ellipsis  text-center",
                                                    style: {
                                                        borderColor: "#FFF"
                                                    },
                                                    children: ele.bl_detail_amount
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "border-x ellipsis  text-center",
                                                    style: {
                                                        borderColor: "#FFF"
                                                    },
                                                    children: NumberFormat(ele.bl_detail_price, 2)
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "border-x ellipsis  text-center",
                                                    style: {
                                                        borderColor: "#FFF"
                                                    },
                                                    children: ele.bl_detail_discounttype == 1 ? NumberFormat(ele.bl_detail_discount, 2) : ele.bl_detail_discount + "%"
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "border-x ellipsis  text-center",
                                                    style: {
                                                        borderColor: "#FFF"
                                                    },
                                                    children: NumberFormat(ele.bl_detail_net, 2)
                                                })
                                            ]
                                        }, i);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-end py-2 border-y ".concat(((_data_BlDetail1 = data.BlDetail) === null || _data_BlDetail1 === void 0 ? void 0 : _data_BlDetail1.length) > 5 && "mt-[100px]" || ((_data_BlDetail2 = data.BlDetail) === null || _data_BlDetail2 === void 0 ? void 0 : _data_BlDetail2.length) < 5 && "mt-[150px]" || ((_data_BlDetail3 = data.BlDetail) === null || _data_BlDetail3 === void 0 ? void 0 : _data_BlDetail3.length) > 10 && "mt-[0px]"),
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[30px]",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold",
                                                children: [
                                                    /*#__PURE__*/ _jsx(AssignmentIcon, {
                                                        fontSize: "18",
                                                        className: "me-1"
                                                    }),
                                                    "สรุป"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[170px]",
                                                children: "มูลค่าสินค้าก่อนส่วนลด"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumrowTotalNet, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex-none w-[170px]",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "ส่วนลด"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "pl-[5px] w-bold",
                                                        children: discounttype == 1 ? NumberFormat(discount, 2) : discount
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "pl-[1px]",
                                                        children: discounttype == 1 ? "บาท" : "%"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumDiscount, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[170px]",
                                                children: "มูลค่าสินค้าหลังหักส่วนลด"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumrowTotalNet - sumDiscount, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex-none w-[170px]",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "ภาษีมูลค่าเพิ่ม"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("span", {
                                                        className: "pl-[5px] w-bold",
                                                        children: [
                                                            formData.bl_billing_vat,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumrowVat, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[170px]",
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "มูลค่าสินค้ารวมภาษีมูลค่าเพิ่ม"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumrowTotalNet - sumDiscount + sumrowVat, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex-none w-[170px]",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "หัก ณ ที่จ่าย"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("span", {
                                                        className: "pl-[5px] w-bold",
                                                        children: [
                                                            formData.bl_billing_tax,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumrowTax, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "grow w-[180px]",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "px-3 pt-3 pb-1 mt-3 mb-2",
                                    style: {
                                        background: "#F6E1E3",
                                        borderRadius: 5
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex mb-2",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "flex-none fs-14 w-[90px] fw-bold",
                                                    children: "มูลค่าสุทธิรวม"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "grow text-end fw-bold text-[#B00412] fs-16 w-[80px]",
                                                    children: NumberFormat(totalnet, 2)
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "flex-none text-[#000] pl-[10px] pt-1",
                                                    children: "บาท"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex mb-2",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-center text-[#000] w-[100px]",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "text-center text-[12.5px] text-[#000] font-semibold",
                                                    children: [
                                                        "( ",
                                                        ThaiBahtText(totalnet, 2),
                                                        " )"
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex items-end py-2 border-b",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "grow w-[100px]",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "flex mb-2",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex-none text-[#000] w-[80px] fw-bold",
                                        children: [
                                            /*#__PURE__*/ _jsx(PaymentsIcon, {
                                                fontSize: "18",
                                                className: "me-1"
                                            }),
                                            " ชำระเงิน"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "growe pr-[10px]",
                                        children: /*#__PURE__*/ _jsx("img", {
                                            src: "/images/bankkbank.png",
                                            className: "mt-[10px] w-[30px]"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex-none w-[220px] text-[#000]",
                                        children: [
                                            /*#__PURE__*/ _jsx("p", {
                                                children: "ธ.กสิกรไทย ( ถนนแจ้งวัฒนะ )"
                                            }),
                                            /*#__PURE__*/ _jsxs("p", {
                                                children: [
                                                    "กระแสรายวัน",
                                                    " ",
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-danger fw-500",
                                                        children: "203-1-87899-6"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                children: "บจก.พาร์เดสโก้ กรุ๊ป"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex items-end py-2",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "grow w-[100px]",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "flex mb-2",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex-none text-[#000] w-[80px] fw-bold",
                                        children: [
                                            /*#__PURE__*/ _jsx(SpeakerNotesIcon, {
                                                fontSize: "18",
                                                className: "me-1"
                                            }),
                                            " หมายเหตุ"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "growe text-[#000] w-[220px] pr-[10px]",
                                        children: data.bl_billing_ramark ? data.bl_billing_ramark : ""
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "py-2 text-[11.5px] my-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "grid grid-cols-3 gap-3",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex items-start justify-start flex-col",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "mb-2",
                                        children: [
                                            "ในนาม ",
                                            partnerInfo.companyName
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex flex-col",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "mb-2"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex items-end justify-end flex-col",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "mb-2",
                                        children: "ในนาม บริษัท พาร์เดสโก้ กรุ๊ป จำกัด"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "py-2 text-[11.5px] my-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "grid grid-cols-5 gap-5",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mb-2",
                                            style: {
                                                color: "#d8d8d8"
                                            },
                                            children: "__________________________________"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "",
                                            children: "ผู้รับวางบิล"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mb-2",
                                            style: {
                                                color: "#d8d8d8"
                                            },
                                            children: "__________________________________"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "",
                                            children: "วันที่"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "mb-2"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mb-2",
                                            style: {
                                                color: "#d8d8d8"
                                            },
                                            children: "__________________________________"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "",
                                            children: "ผู้วางบิล"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mb-2 border-b px-4",
                                            children: moment(data.bl_billing_issuedate).format("DD/MM/YYYY")
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "",
                                            children: "วันที่"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "text-[12.5px] text-[#2C2C2C] mb-1",
                style: {
                    width: "210mm",
                    height: "297mm",
                    padding: "5px 30px",
                    margin: "0",
                    background: "white",
                    position: "relative"
                },
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "row gx-xl-4",
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-6",
                                children: /*#__PURE__*/ _jsx("div", {
                                    className: "mt-3",
                                    children: /*#__PURE__*/ _jsx("img", {
                                        src: "/images/logopardesco.png",
                                        className: "w-[100px]"
                                    })
                                })
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "col-6 text-end",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "mt-3",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "ml-5",
                                            children: "(สำเนา)"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "fs-18 text-danger fw-bold",
                                            children: "ใบแจ้งหนี้"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-end mt-2",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[20px]",
                                style: {
                                    borderBottom: "1px solid #909090"
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[40px]",
                                                children: "ผู้ขาย :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[250px]",
                                                children: "บริษัท พาร์เดสโก้ กรุ๊ป จำกัด (สำนักงานใหญ่ )"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[40px]",
                                                children: "ที่อยู่ :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[250px]",
                                                children: "241/54 ซอยกาญจนาภิเษก 0015 แขวงศาลาธรรมสพน์ เขตทวีวัฒนา กรุงเทพ 10170"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[130px]",
                                                children: "เลขประจำตัวผู้เสียภาษี :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[150px]",
                                                children: "0105568029236"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[60px]"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[250px]"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[20px]",
                                style: {
                                    borderBottom: "1px solid #909090"
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[40px]",
                                                children: "ติดต่อ :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[100px]",
                                                children: "วริธร สวยงาม"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(PhoneIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[100px]",
                                                children: "094-928-0297"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(EmailIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[100px]",
                                                children: "-"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(LanguageIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[100px]",
                                                children: "-"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[20px] px-2 pt-2",
                                style: {
                                    background: "#F6E1E3",
                                    borderRadius: 5
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[100px]",
                                                children: "เลขที่เอกสาร :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[80px]",
                                                children: data.bl_billing_code
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[100px]",
                                                children: "วันที่ออกเอกสาร :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[80px]",
                                                children: moment(data.bl_billing_issuedate).format("DD/MM/YYYY")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[100px]",
                                                children: "วันที่ครบกำหนด :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[80px]",
                                                children: moment(data.bl_billing_expiredate).format("DD/MM/YYYY")
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex flex-end mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[100px]",
                                                children: "อ้างอิง :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[80px]",
                                                children: data.QrQuotation ? data.QrQuotation.qr_quotation_code : "-"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-end mt-2",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[20px]",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[40px]",
                                                children: "ลูกค้า :"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "grow text-[#000] w-[250px]",
                                                children: [
                                                    partnerInfo.companyName,
                                                    " ",
                                                    partnerInfo.companyBranch ? "(สาขา".concat(partnerInfo.companyBranch, ")") : ""
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[40px]",
                                                children: "ที่อยู่ :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[250px]",
                                                children: /*#__PURE__*/ _jsxs(_Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ _jsxs("p", {
                                                            children: [
                                                                partnerInfo.companyAddress + " " + partnerInfo.companySubDistrict,
                                                                " "
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx("p", {
                                                            children: partnerInfo.companyDistrict + " " + partnerInfo.companyProvince + " " + partnerInfo.companyZipCode
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[130px]",
                                                children: "เลขประจำตัวผู้เสียภาษี :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[150px]",
                                                children: partnerInfo.companyTaxId ? partnerInfo.companyTaxId : "-"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[70px]"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[250px]"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[20px]",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[50px]",
                                                children: "ผู้ติดต่อ :"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[220px]",
                                                children: partnerInfo.contractName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(PhoneIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[220px]",
                                                children: partnerInfo.contactPhone
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(EmailIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[220px]",
                                                children: partnerInfo.contactEmail
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[20px]",
                                                children: /*#__PURE__*/ _jsx(LanguageIcon, {
                                                    fontSize: "12"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[220px]",
                                                children: "-"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "grow pr-[20px] px-2 pt-2",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "flex mb-2",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex-none w-[100px]"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "grow text-[#000]"
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "py-1",
                        children: /*#__PURE__*/ _jsxs("table", {
                            className: "w-full table-print",
                            children: [
                                /*#__PURE__*/ _jsx("thead", {
                                    style: {
                                        background: "#F6E1E3",
                                        borderRadius: 2,
                                        borderColor: "#F6E1E3"
                                    },
                                    children: /*#__PURE__*/ _jsxs("tr", {
                                        children: [
                                            /*#__PURE__*/ _jsx("th", {
                                                valign: "middle",
                                                width: "6%",
                                                style: {
                                                    width: "6%"
                                                },
                                                className: "border-x border-y  text-center font-normal",
                                                children: "รายการ"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                valign: "middle",
                                                width: "2%",
                                                style: {
                                                    width: "2%"
                                                },
                                                className: "border-x border-y  text-center font-normal",
                                                children: "จำนวน"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                valign: "middle",
                                                width: "2%",
                                                style: {
                                                    width: "2%"
                                                },
                                                className: "border-x border-y  text-center font-normal",
                                                children: "ราคาต่อหน่วย"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                valign: "middle",
                                                width: "2%",
                                                style: {
                                                    width: "2%"
                                                },
                                                className: "border-x border-y  text-center font-normal",
                                                children: "ส่วนลด"
                                            }),
                                            /*#__PURE__*/ _jsx("th", {
                                                valign: "middle",
                                                width: "2%",
                                                style: {
                                                    width: "2%"
                                                },
                                                className: "border-x border-y  text-center font-normal",
                                                children: "ราคารวม"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("tbody", {
                                    children: data === null || data === void 0 ? void 0 : (_data_BlDetail4 = data.BlDetail) === null || _data_BlDetail4 === void 0 ? void 0 : _data_BlDetail4.map(function(ele, i) {
                                        return /*#__PURE__*/ _jsxs("tr", {
                                            style: {
                                                height: "30px"
                                            },
                                            children: [
                                                /*#__PURE__*/ _jsxs("td", {
                                                    className: "border-x ellipsis",
                                                    style: {
                                                        borderColor: "#FFF"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ _jsx("p", {
                                                            children: "".concat(i + 1, ". ").concat(ele.bl_detail_name)
                                                        }),
                                                        /*#__PURE__*/ _jsx("p", {
                                                            children: "".concat(ele.bl_detail_remark ? "(" + ele.bl_detail_remark + ")" : "")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "border-x ellipsis  text-center",
                                                    style: {
                                                        borderColor: "#FFF"
                                                    },
                                                    children: ele.bl_detail_amount
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "border-x ellipsis  text-center",
                                                    style: {
                                                        borderColor: "#FFF"
                                                    },
                                                    children: NumberFormat(ele.bl_detail_price, 2)
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "border-x ellipsis  text-center",
                                                    style: {
                                                        borderColor: "#FFF"
                                                    },
                                                    children: NumberFormat(ele.bl_detail_discount, 2)
                                                }),
                                                /*#__PURE__*/ _jsx("td", {
                                                    className: "border-x ellipsis  text-center",
                                                    style: {
                                                        borderColor: "#FFF"
                                                    },
                                                    children: NumberFormat(ele.bl_detail_net, 2)
                                                })
                                            ]
                                        }, i);
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-end py-2 border-y ".concat(((_data_BlDetail5 = data.BlDetail) === null || _data_BlDetail5 === void 0 ? void 0 : _data_BlDetail5.length) > 5 && "mt-[100px]" || ((_data_BlDetail6 = data.BlDetail) === null || _data_BlDetail6 === void 0 ? void 0 : _data_BlDetail6.length) < 5 && "mt-[150px]" || ((_data_BlDetail7 = data.BlDetail) === null || _data_BlDetail7 === void 0 ? void 0 : _data_BlDetail7.length) > 10 && "mt-[0px]"),
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "grow pr-[30px]",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold",
                                                children: [
                                                    /*#__PURE__*/ _jsx(AssignmentIcon, {
                                                        fontSize: "18",
                                                        className: "me-1"
                                                    }),
                                                    "สรุป"
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[170px]",
                                                children: "มูลค่าสินค้าก่อนส่วนลด"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumrowTotalNet, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex-none w-[170px]",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "ส่วนลด"
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "pl-[5px] w-bold",
                                                        children: discounttype == 1 ? NumberFormat(discount, 2) : discount
                                                    }),
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "pl-[1px]",
                                                        children: discounttype == 1 ? "บาท" : "%"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumDiscount, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[170px]",
                                                children: "มูลค่าสินค้าหลังหักส่วนลด"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumrowTotalNet - sumDiscount, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex-none w-[170px]",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "ภาษีมูลค่าเพิ่ม"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("span", {
                                                        className: "pl-[5px] w-bold",
                                                        children: [
                                                            formData.bl_billing_vat,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumrowVat, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold"
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none w-[170px]",
                                                children: /*#__PURE__*/ _jsx("span", {
                                                    children: "มูลค่าสินค้ารวมภาษีมูลค่าเพิ่ม"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumrowTotalNet - sumDiscount + sumrowVat, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex mb-2",
                                        children: [
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-[#000] w-[20px] fw-bold"
                                            }),
                                            /*#__PURE__*/ _jsxs("div", {
                                                className: "flex-none w-[170px]",
                                                children: [
                                                    /*#__PURE__*/ _jsx("span", {
                                                        children: "หัก ณ ที่จ่าย"
                                                    }),
                                                    /*#__PURE__*/ _jsxs("span", {
                                                        className: "pl-[5px] w-bold",
                                                        children: [
                                                            formData.bl_billing_tax,
                                                            "%"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-end fw-bold text-[#000] w-[80px]",
                                                children: NumberFormat(sumrowTax, 2)
                                            }),
                                            /*#__PURE__*/ _jsx("div", {
                                                className: "flex-none text-[#000] pl-[10px]",
                                                children: "บาท"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "grow w-[180px]",
                                children: /*#__PURE__*/ _jsxs("div", {
                                    className: "px-3 pt-3 pb-1 mt-3 mb-2",
                                    style: {
                                        background: "#F6E1E3",
                                        borderRadius: 5
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "flex mb-2",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "flex-none fs-14 w-[90px] fw-bold",
                                                    children: "มูลค่าสุทธิรวม"
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "grow text-end fw-bold text-[#B00412] fs-16 w-[80px]",
                                                    children: NumberFormat(totalnet, 2)
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "flex-none text-[#000] pl-[10px] pt-1",
                                                    children: "บาท"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "flex mb-2",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "grow text-center text-[#000] w-[100px]",
                                                children: /*#__PURE__*/ _jsxs("div", {
                                                    className: "text-center text-[12.5px] text-[#000] font-semibold",
                                                    children: [
                                                        "( ",
                                                        ThaiBahtText(totalnet, 2),
                                                        " )"
                                                    ]
                                                })
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex items-end py-2 border-b",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "grow w-[100px]",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "flex mb-2",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex-none text-[#000] w-[80px] fw-bold",
                                        children: [
                                            /*#__PURE__*/ _jsx(PaymentsIcon, {
                                                fontSize: "18",
                                                className: "me-1"
                                            }),
                                            " ชำระเงิน"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "growe pr-[10px]",
                                        children: /*#__PURE__*/ _jsx("img", {
                                            src: "/images/bankkbank.png",
                                            className: "mt-[10px] w-[30px]"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex-none w-[220px] text-[#000]",
                                        children: [
                                            /*#__PURE__*/ _jsx("p", {
                                                children: "ธ.กสิกรไทย ( ถนนแจ้งวัฒนะ )"
                                            }),
                                            /*#__PURE__*/ _jsxs("p", {
                                                children: [
                                                    "กระแสรายวัน",
                                                    " ",
                                                    /*#__PURE__*/ _jsx("span", {
                                                        className: "text-danger fw-500",
                                                        children: "203-1-87899-6"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx("p", {
                                                children: "บจก.พาร์เดสโก้ กรุ๊ป"
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "flex items-end py-2",
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "grow w-[100px]",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "flex mb-2",
                                children: [
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "flex-none text-[#000] w-[80px] fw-bold",
                                        children: [
                                            /*#__PURE__*/ _jsx(SpeakerNotesIcon, {
                                                fontSize: "18",
                                                className: "me-1"
                                            }),
                                            " หมายเหตุ"
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "growe text-[#000] w-[220px] pr-[10px]",
                                        children: data.bl_billing_ramark ? data.bl_billing_ramark : ""
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "py-2 text-[11.5px] my-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "grid grid-cols-3 gap-3",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex items-start justify-start flex-col",
                                    children: /*#__PURE__*/ _jsxs("div", {
                                        className: "mb-2",
                                        children: [
                                            "ในนาม ",
                                            partnerInfo.companyName
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex flex-col",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "mb-2"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex items-end justify-end flex-col",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "mb-2",
                                        children: "ในนาม บริษัท พาร์เดสโก้ กรุ๊ป จำกัด"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "py-2 text-[11.5px] my-3",
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "grid grid-cols-5 gap-5",
                            children: [
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mb-2",
                                            style: {
                                                color: "#d8d8d8"
                                            },
                                            children: "__________________________________"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "",
                                            children: "ผู้รับวางบิล"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mb-2",
                                            style: {
                                                color: "#d8d8d8"
                                            },
                                            children: "__________________________________"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "",
                                            children: "วันที่"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "mb-2"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mb-2",
                                            style: {
                                                color: "#d8d8d8"
                                            },
                                            children: "__________________________________"
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "",
                                            children: "ผู้วางบิล"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "flex items-center justify-center  flex-col",
                                    children: [
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "mb-2 border-b px-4",
                                            children: moment(data.bl_billing_issuedate).format("DD/MM/YYYY")
                                        }),
                                        /*#__PURE__*/ _jsx("div", {
                                            className: "",
                                            children: "วันที่"
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
function SuccessModal(_param) {
    var navigate = _param.navigate, show = _param.show, direction = _param.direction, props = _object_without_properties(_param, [
        "navigate",
        "show",
        "direction"
    ]);
    var handleCloseAndNavigate = function() {
        props.onHide();
        if (direction) {
            navigate(direction);
        }
    };
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        show: show,
        onHide: handleCloseAndNavigate,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "84",
                            height: "83",
                            viewBox: "0 0 84 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            className: "mx-auto",
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "42",
                                    cy: "41.5",
                                    r: "41.5",
                                    fill: "#2DC76D"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M56.0123 30.9902L36.7444 50.2581L27.9863 41.5",
                                    stroke: "white",
                                    strokeWidth: "5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fs-18 tc-7",
                        children: props.textsuccess
                    })
                ]
            })
        })
    }));
}
// register ฟอนต์
Font.register({
    family: "THSarabun",
    fonts: [
        {
            src: thsarabun
        },
        {
            src: thsarabunBold,
            fontWeight: "bold"
        }
    ]
});
var styles = StyleSheet.create({
    page: {
        fontFamily: "THSarabun",
        fontSize: 12,
        padding: 30,
        backgroundColor: "#fff",
        lineHeight: 1.4
    },
    headerRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 12,
        alignItems: "center"
    },
    logo: {
        width: 90
    },
    logoBank: {
        width: 40
    },
    subTitle: {
        fontSize: 12,
        marginBottom: 2,
        color: "#333"
    },
    title: {
        fontSize: 18,
        fontWeight: "bold",
        color: "#B00412"
    },
    titleBox: {
        textAlign: "right"
    },
    titleCenter: {
        textAlign: "center"
    },
    sectionGroup: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 12
    },
    col6: {
        flex: 1
    },
    textEnd: {
        textAlign: "right"
    },
    sectionBox: {
        flex: 1,
        padding: 6,
        marginRight: 8,
        borderBottom: "1px solid #CCC"
    },
    sectionLabel: {
        fontSize: 12,
        color: "#555"
    },
    sectionValue: {
        fontSize: 12,
        fontWeight: "bold",
        marginTop: 2
    },
    docInfoBox: {
        flex: 1,
        padding: 6,
        marginLeft: 8,
        borderRadius: 4,
        backgroundColor: "#FDECEC"
    },
    docInfoRow: {
        flexDirection: "row",
        justifyContent: "space-between",
        marginBottom: 4
    },
    docLabel: {
        fontSize: 12,
        color: "#333"
    },
    docValue: {
        fontSize: 12,
        fontWeight: "bold"
    },
    table: {
        display: "table",
        width: "auto",
        marginTop: 2
    },
    tableRow: {
        flexDirection: "row"
    },
    tableHeader: {
        flex: 1,
        borderRight: "1px solid #E2E8F0",
        backgroundColor: "#F6E1E3",
        padding: 6,
        fontSize: 12,
        fontWeight: "bold",
        textAlign: "center"
    },
    tableCell: {
        flex: 1,
        borderRight: "0px solid #E2E8F0",
        borderTop: "0px solid #E2E8F0",
        padding: 5,
        fontSize: 11,
        textAlign: "center"
    },
    footer: {
        marginTop: 24,
        textAlign: "right",
        fontSize: 11
    },
    footerSection: {
        paddingVertical: 8,
        fontSize: 11.5,
        marginVertical: 6
    },
    footerRow: {
        flexDirection: "row",
        justifyContent: "space-between"
    },
    footerColLeft: {
        flex: 1,
        justifyContent: "flex-start"
    },
    footerColCenter: {
        flex: 1,
        alignItems: "center"
    },
    footerColRight: {
        flex: 1,
        alignItems: "flex-end"
    },
    signSection: {
        paddingVertical: 8,
        fontSize: 11.5,
        marginVertical: 6,
        paddingHorizontal: 12
    },
    signRow: {
        flexDirection: "row",
        justifyContent: "space-between"
    },
    signCol: {
        flex: 1,
        alignItems: "center"
    },
    signLine: {
        color: "#d8d8d8",
        marginBottom: 4
    },
    signDate: {
        borderBottomWidth: 1,
        borderColor: "#d8d8d8",
        paddingHorizontal: 45,
        marginBottom: 4
    }
});
var PagePrintPDF = function(param) {
    var data = param.data, partnerInfo = param.partnerInfo, sumDiscount = param.sumDiscount, sumrowVat = param.sumrowVat, sumrowTax = param.sumrowTax, sumrowTotalNet = param.sumrowTotalNet, formData = param.formData;
    var _data_BlDetail, _data_BlDetail1, _data_BlDetail2, _data_BlDetail3, _data_BlDetail4;
    var discounttype = formData.bl_billing_discounttype ? formData.bl_billing_discounttype : 1;
    var discount = formData.bl_billing_discount ? formData.bl_billing_discount : 0;
    var totalnet = formData.bl_billing_totalnet ? formData.bl_billing_totalnet : 0;
    return /*#__PURE__*/ _jsx(Document, {
        children: /*#__PURE__*/ _jsxs(Page, {
            size: "A4",
            style: styles.page,
            children: [
                /*#__PURE__*/ _jsxs(View, {
                    style: styles.headerRow,
                    children: [
                        /*#__PURE__*/ _jsx(Image, {
                            src: "/images/logopardesco.png",
                            style: styles.logo
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                flex: 1,
                                alignItems: "flex-end"
                            },
                            children: [
                                /*#__PURE__*/ _jsx(Text, {
                                    style: styles.subTitle,
                                    children: "(ต้นฉบับ)"
                                }),
                                /*#__PURE__*/ _jsx(Text, {
                                    style: styles.title,
                                    children: "ใบแจ้งหนี้"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: {
                        flexDirection: "row",
                        marginTop: 3
                    },
                    children: [
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 250,
                                borderBottom: "1px solid #ebecec",
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ผู้ขาย :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บริษัท พาร์เดสโก้ กรุ๊ป จำากัด (สำนักงานใหญ่)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ที่อยู่ :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "241/54 ซอยกาญจนาภิเษก 0015 แขวงศาลาธรรมสพน์ เขตทวีวัฒนา กรุงเทพ 10170"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 80
                                            },
                                            children: "เลขประจำตัวผู้เสียภาษี :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "0105568029236"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 150,
                                borderBottom: "1px solid #ebecec",
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ติดต่อ :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "วริธร สวยงาม"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "โทร."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: "0949280297"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "อีเมล์."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: "-"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ลิงก์."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: "-"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                backgroundColor: "#F6E1E3",
                                borderRadius: 5,
                                padding: 6,
                                width: 150
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 60
                                            },
                                            children: "เลขที่เอกสาร :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: data.bl_billing_code
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 60
                                            },
                                            children: "วันที่ออกเอกสาร :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: moment(data.inv_invoice_issuedate).format("DD/MM/YYYY")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 60
                                            },
                                            children: "วันที่ครบกำหนด :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: moment(data.inv_invoice_expiredate).format("DD/MM/YYYY")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 60
                                            },
                                            children: "อ้างอิง :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: data.QrQuotation ? data.QrQuotation.qr_quotation_code : "-"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: {
                        flexDirection: "row",
                        marginTop: 3
                    },
                    children: [
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 240,
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ลูกค้า :"
                                        }),
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: [
                                                partnerInfo.companyName,
                                                " ",
                                                partnerInfo.companyBranch ? "(สาขา".concat(partnerInfo.companyBranch, ")") : ""
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ที่อยู่ :"
                                        }),
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: [
                                                partnerInfo.companyAddress + " " + partnerInfo.companySubDistrict,
                                                " ",
                                                partnerInfo.companyDistrict + " " + partnerInfo.companyProvince + " " + partnerInfo.companyZipCode
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 80
                                            },
                                            children: "เลขประจำตัวผู้เสียภาษี :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: partnerInfo.companyTaxId ? partnerInfo.companyTaxId : "-"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 150,
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ผู้ติดต่อ :"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: partnerInfo.contractName
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "โทร."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: partnerInfo.contactPhone
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "อีเมล์."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: partnerInfo.contactEmail
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 30
                                            },
                                            children: "ลิงก์."
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            children: "-"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: styles.table,
                    children: [
                        /*#__PURE__*/ _jsx(View, {
                            style: styles.tableRow,
                            children: [
                                "รายการ",
                                "จำนวน",
                                "ราคาต่อหน่วย",
                                "ส่วนลด",
                                "ราคารวม"
                            ].map(function(h, i) {
                                return /*#__PURE__*/ _jsx(Text, {
                                    style: styles.tableHeader,
                                    children: h
                                }, i);
                            })
                        }),
                        (data === null || data === void 0 ? void 0 : data.BlDetail) && (data === null || data === void 0 ? void 0 : (_data_BlDetail = data.BlDetail) === null || _data_BlDetail === void 0 ? void 0 : _data_BlDetail.length) > 0 ? data === null || data === void 0 ? void 0 : (_data_BlDetail1 = data.BlDetail) === null || _data_BlDetail1 === void 0 ? void 0 : _data_BlDetail1.map(function(ele, i) {
                            return /*#__PURE__*/ _jsxs(View, {
                                style: styles.tableRow,
                                children: [
                                    /*#__PURE__*/ _jsxs(View, {
                                        style: [
                                            styles.tableCell,
                                            {
                                                alignItems: "flex-start"
                                            }
                                        ],
                                        children: [
                                            /*#__PURE__*/ _jsx(Text, {
                                                children: "".concat(i + 1, ". ").concat(ele.bl_detail_name)
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                children: ele.bl_detail_remark ? "(" + ele.bl_detail_remark + ")" : ""
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCell,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            children: ele.bl_detail_amount
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCell,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            children: NumberFormat(ele.bl_detail_price, 2)
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCell,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            children: ele.bl_detail_discounttype == 1 ? NumberFormat(ele.bl_detail_discount, 2) : ele.bl_detail_discount + "%"
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: styles.tableCell,
                                        children: /*#__PURE__*/ _jsx(Text, {
                                            children: NumberFormat(ele.bl_detail_net, 2)
                                        })
                                    })
                                ]
                            }, i);
                        }) : /*#__PURE__*/ _jsx(View, {
                            style: styles.tableRow,
                            children: /*#__PURE__*/ _jsx(Text, {
                                style: [
                                    styles.tableCell,
                                    {
                                        flex: 1
                                    }
                                ],
                                children: "ไม่พบข้อมูล"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: {
                        flexDirection: "row",
                        marginTop: ((_data_BlDetail2 = data.BlDetail) === null || _data_BlDetail2 === void 0 ? void 0 : _data_BlDetail2.length) > 5 && 100 || ((_data_BlDetail3 = data.BlDetail) === null || _data_BlDetail3 === void 0 ? void 0 : _data_BlDetail3.length) < 5 && 100 || ((_data_BlDetail4 = data.BlDetail) === null || _data_BlDetail4 === void 0 ? void 0 : _data_BlDetail4.length) > 10 && 10,
                        borderBottom: "1px solid #ebecec",
                        borderTop: "1px solid #ebecec",
                        padding: "10px 2px"
                    },
                    children: [
                        /*#__PURE__*/ _jsx(View, {
                            style: {
                                width: 40,
                                paddingRight: 10
                            },
                            children: /*#__PURE__*/ _jsx(View, {
                                style: {
                                    width: 40,
                                    paddingRight: 10
                                },
                                children: /*#__PURE__*/ _jsx(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4,
                                        fontWeight: "bold"
                                    },
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            width: 30
                                        },
                                        children: "สรุป"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 250,
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: "มูลค่าสินค้าก่อนส่วนลด"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumrowTotalNet, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: [
                                                "ส่วนลด",
                                                " ",
                                                discounttype == 1 ? NumberFormat(discount, 2) : discount,
                                                " ",
                                                discounttype == 1 ? "บาท" : "เปอร์เซ็น"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumDiscount, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: "มูลค่าสินค้าหลังหักส่วนลด"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumrowTotalNet - sumDiscount, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: "ภาษีมูลค่าเพิ่ม"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumrowVat, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 4
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: "มูลค่าสินค้ารวมภาษีมูลค่าเพิ่ม"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumrowTotalNet - sumDiscount + sumrowVat, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row"
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 120
                                            },
                                            children: [
                                                "หัก ณ ที่จ่าย ",
                                                formData.bl_billing_tax,
                                                "%"
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: [
                                                styles.textEnd,
                                                {
                                                    width: 50,
                                                    marginRight: 3,
                                                    fontWeight: "bold"
                                                }
                                            ],
                                            children: NumberFormat(sumrowTax, 2)
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1
                                            },
                                            children: "บาท"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(View, {
                            style: [
                                styles.docValue,
                                {
                                    width: 200,
                                    paddingRight: 10,
                                    fontSize: 13
                                }
                            ],
                            children: /*#__PURE__*/ _jsxs(View, {
                                style: {
                                    backgroundColor: "#F6E1E3",
                                    borderRadius: 5,
                                    padding: 6
                                },
                                children: [
                                    /*#__PURE__*/ _jsxs(View, {
                                        style: {
                                            flexDirection: "row",
                                            marginBottom: 4
                                        },
                                        children: [
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: {
                                                    width: 100
                                                },
                                                children: "มูลค่าสุทธิรวม"
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: [
                                                    styles.textEnd,
                                                    {
                                                        width: 50,
                                                        marginRight: 3,
                                                        color: "#b00412",
                                                        fontWeight: 700
                                                    }
                                                ],
                                                children: NumberFormat(totalnet, 2)
                                            }),
                                            /*#__PURE__*/ _jsx(Text, {
                                                style: {
                                                    flex: 1
                                                },
                                                children: "บาท"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(View, {
                                        style: [
                                            styles.titleCenter,
                                            {
                                                flexDirection: "row",
                                                marginBottom: 4
                                            }
                                        ],
                                        children: /*#__PURE__*/ _jsxs(Text, {
                                            style: {
                                                width: 200
                                            },
                                            children: [
                                                "( ",
                                                ThaiBahtText(totalnet, 2),
                                                " )"
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(View, {
                    style: {
                        flexDirection: "row",
                        borderBottom: "1px solid #ebecec",
                        marginTop: 3
                    },
                    children: [
                        /*#__PURE__*/ _jsx(View, {
                            style: {
                                width: 40,
                                paddingRight: 10
                            },
                            children: /*#__PURE__*/ _jsx(View, {
                                style: {
                                    flexDirection: "row",
                                    marginBottom: 4,
                                    fontWeight: "bold"
                                },
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: {
                                        width: 40
                                    },
                                    children: "ชำระเงิน"
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(View, {
                            style: {
                                width: 40,
                                paddingRight: 10
                            },
                            children: /*#__PURE__*/ _jsx(View, {
                                style: {
                                    flexDirection: "row",
                                    marginBottom: 4,
                                    paddingTop: 2
                                },
                                children: /*#__PURE__*/ _jsx(Image, {
                                    src: "/images/bankkbank.png",
                                    style: styles.logoBank
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsxs(View, {
                            style: {
                                width: 250,
                                paddingRight: 10
                            },
                            children: [
                                /*#__PURE__*/ _jsx(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 2
                                    },
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            width: 200
                                        },
                                        children: "ธ.กสิกรไทย ( ถนนแจ้งวัฒนะ )"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 2
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                width: 50
                                            },
                                            children: "กระแสรายวัน"
                                        }),
                                        /*#__PURE__*/ _jsx(Text, {
                                            style: {
                                                flex: 1,
                                                color: "#b00412",
                                                fontWeight: "700"
                                            },
                                            children: "203-1-87899-6"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 2
                                    },
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            width: 200
                                        },
                                        children: "บจก.พาร์เดสโก้ กรุ๊ป"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(View, {
                    style: {
                        flexDirection: "row",
                        marginTop: 3
                    },
                    children: /*#__PURE__*/ _jsxs(View, {
                        style: {
                            width: 40,
                            paddingRight: 10
                        },
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: {
                                    flexDirection: "row",
                                    marginBottom: 4,
                                    fontWeight: "bold"
                                },
                                children: /*#__PURE__*/ _jsx(Text, {
                                    style: {
                                        width: 40
                                    },
                                    children: "หมายเหตุ"
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: {
                                    width: 250,
                                    paddingRight: 10
                                },
                                children: /*#__PURE__*/ _jsx(View, {
                                    style: {
                                        flexDirection: "row",
                                        marginBottom: 1
                                    },
                                    children: /*#__PURE__*/ _jsx(Text, {
                                        children: data.bl_billing_ramark ? data.bl_billing_ramark : ""
                                    })
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(View, {
                    style: styles.footerSection,
                    children: /*#__PURE__*/ _jsxs(View, {
                        style: styles.footerRow,
                        children: [
                            /*#__PURE__*/ _jsx(View, {
                                style: styles.footerColLeft,
                                children: /*#__PURE__*/ _jsxs(Text, {
                                    children: [
                                        "ในนาม ",
                                        (partnerInfo === null || partnerInfo === void 0 ? void 0 : partnerInfo.companyName) || "-"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: styles.footerColCenter,
                                children: /*#__PURE__*/ _jsx(Text, {
                                    children: " "
                                })
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: styles.footerColRight,
                                children: /*#__PURE__*/ _jsx(Text, {
                                    children: "ในนาม บริษัท พาร์เดสโก้ กรุ๊ป จำกัด"
                                })
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(View, {
                    style: styles.signSection,
                    children: /*#__PURE__*/ _jsxs(View, {
                        style: styles.signRow,
                        children: [
                            /*#__PURE__*/ _jsxs(View, {
                                style: styles.signCol,
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            marginBottom: 5
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signLine,
                                        children: "________________________________"
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: "ผู้จ่าย"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(View, {
                                style: styles.signCol,
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            marginBottom: 5
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signLine,
                                        children: "________________________________"
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: "วันที่"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx(View, {
                                style: styles.signCol,
                                children: /*#__PURE__*/ _jsx(Text, {
                                    children: " "
                                })
                            }),
                            /*#__PURE__*/ _jsxs(View, {
                                style: [
                                    styles.signCol,
                                    {
                                        paddingRight: 4
                                    }
                                ],
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            marginBottom: 5,
                                            width: "50%"
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: styles.signLine,
                                        children: "________________________________"
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: "ผู้รับเงิน"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(View, {
                                style: styles.signCol,
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        style: {
                                            marginBottom: 4,
                                            paddingLeft: 4,
                                            borderBottom: "1px soild #ebecec",
                                            width: "100%",
                                            textAlign: "center"
                                        },
                                        children: (data === null || data === void 0 ? void 0 : data.bl_billing_issuedate) ? moment(data.bl_billing_issuedate).format("DD/MM/YYYY") : ""
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        children: "วันที่"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
